/* ------------------------------------------------------------------ *
 *  Front Desk – API catalog (GENERATED from the controllers of the 12 services).
 *  One entry per public endpoint the gateway exposes: method, path, response kind and the
 *  request / query fields of its DTOs. Do not edit by hand; regenerate when a controller changes.
 *    t: s text · n number · b yes/no · g id · dt date+time · d date · sa text list · ga id list · na number list · j JSON
 *    k: paged (PagedResult) · list (array) · obj (one object) · none (no body) · file (download)
 * ------------------------------------------------------------------ */

export type FieldType = "s" | "n" | "b" | "g" | "dt" | "d" | "sa" | "ga" | "na" | "j";
export interface FieldDef {
  n: string;
  t: FieldType;
  r?: 1;
  o?: string[];
  d?: string | number | boolean;
  h?: string;
}
export type Method = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
export type Kind = "paged" | "list" | "obj" | "none" | "file";
export interface EndpointDef {
  m: Method;
  p: string;
  a: string;
  k: Kind;
  h?: string;
  b?: FieldDef[];
  q?: FieldDef[];
  qp?: string[];
  x?: 1;
  perm?: string;
}
export interface SectionDef {
  key: string;
  label: string;
  eps: EndpointDef[];
}
export interface ModuleDef {
  key: string;
  label: string;
  icon: string;
  sections: SectionDef[];
}

export const MODULES: ModuleDef[] = [
 {
  "key": "calls",
  "label": "Calls",
  "icon": "M6.6 10.8a15 15 0 006.6 6.6l2.2-2.2a1 1 0 011-.25 11.4 11.4 0 003.6.6 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.6 3.6a1 1 0 01-.25 1z",
  "sections": [
   {
    "key": "Calls",
    "label": "Calls",
    "eps": [
     {
      "m": "GET",
      "p": "/api/calls",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "direction",
        "t": "s"
       },
       {
        "n": "outcome",
        "t": "s"
       },
       {
        "n": "state",
        "t": "s"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "poolId",
        "t": "g"
       },
       {
        "n": "numberId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "dispositionId",
        "t": "g"
       },
       {
        "n": "fromNumber",
        "t": "s"
       },
       {
        "n": "toNumber",
        "t": "s"
       },
       {
        "n": "answered",
        "t": "b"
       },
       {
        "n": "recorded",
        "t": "b"
       },
       {
        "n": "conversion",
        "t": "b"
       },
       {
        "n": "voicemail",
        "t": "b"
       },
       {
        "n": "minDuration",
        "t": "n"
       },
       {
        "n": "maxDuration",
        "t": "n"
       },
       {
        "n": "sentiment",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/calls/live",
      "a": "Live",
      "k": "list",
      "h": "Calls happening right now. The same updates are pushed over the SignalR hub (/hubs/calls).",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/calls/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "PATCH",
      "p": "/api/calls/{id}",
      "a": "Update",
      "k": "obj",
      "h": "Notes and tags on a call.",
      "b": [
       {
        "n": "note",
        "t": "s"
       },
       {
        "n": "tags",
        "t": "s"
       }
      ],
      "perm": "Disposition"
     },
     {
      "m": "POST",
      "p": "/api/calls/dial",
      "a": "Dial",
      "k": "obj",
      "h": "Click-to-dial: rings the agent, then the customer, from one of the tenant's tracking numbers.",
      "b": [
       {
        "n": "to",
        "t": "s",
        "r": 1,
        "h": "Customer number to call."
       },
       {
        "n": "fromNumberId",
        "t": "g",
        "h": "The tracking number shown to the customer as caller ID (one of this tenant's numbers)."
       },
       {
        "n": "fromNumber",
        "t": "s"
       },
       {
        "n": "agentId",
        "t": "g",
        "h": "Who takes the call on the agent side: an agent known to the Agents service..."
       },
       {
        "n": "agentSipUsername",
        "t": "s",
        "h": "...or a WebRTC / SIP username..."
       },
       {
        "n": "agentNumber",
        "t": "s",
        "h": "...or a phone number that rings the agent."
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "record",
        "t": "b"
       },
       {
        "n": "callbackId",
        "t": "g",
        "h": "Optional link back to the callback this call fulfils."
       }
      ],
      "perm": "Dial"
     },
     {
      "m": "POST",
      "p": "/api/calls/{id}/hangup",
      "a": "Hangup",
      "k": "none",
      "perm": "Control"
     },
     {
      "m": "POST",
      "p": "/api/calls/{id}/transfer",
      "a": "Transfer",
      "k": "none",
      "b": [
       {
        "n": "to",
        "t": "s",
        "r": 1,
        "h": "E.164 number or sip: URI to move the caller to."
       },
       {
        "n": "ringSeconds",
        "t": "n",
        "d": 30
       }
      ],
      "perm": "Control"
     },
     {
      "m": "POST",
      "p": "/api/calls/{id}/recording/pause",
      "a": "PauseRecording",
      "k": "none",
      "perm": "Control"
     },
     {
      "m": "POST",
      "p": "/api/calls/{id}/recording/resume",
      "a": "ResumeRecording",
      "k": "none",
      "perm": "Control"
     },
     {
      "m": "POST",
      "p": "/api/calls/{id}/supervise",
      "a": "Supervise",
      "k": "obj",
      "h": "Listen to (monitor), coach (whisper) or join (barge) a live call.",
      "b": [
       {
        "n": "role",
        "t": "s",
        "r": 1,
        "d": "monitor",
        "h": "monitor (listen only) | whisper (agent hears you) | barge (everyone hears you)"
       },
       {
        "n": "supervisorSipUsername",
        "t": "s"
       },
       {
        "n": "supervisorNumber",
        "t": "s"
       }
      ],
      "perm": "Supervise"
     },
     {
      "m": "PUT",
      "p": "/api/calls/{id}/supervise/{legId}/role",
      "a": "SwitchSupervisorRole",
      "k": "obj",
      "b": [
       {
        "n": "role",
        "t": "s",
        "r": 1,
        "d": "monitor"
       }
      ],
      "perm": "Supervise"
     },
     {
      "m": "PUT",
      "p": "/api/calls/{id}/disposition",
      "a": "SetDisposition",
      "k": "obj",
      "b": [
       {
        "n": "dispositionId",
        "t": "g",
        "r": 1
       },
       {
        "n": "note",
        "t": "s"
       }
      ],
      "perm": "Disposition"
     }
    ]
   },
   {
    "key": "Callbacks",
    "label": "Callbacks",
    "eps": [
     {
      "m": "GET",
      "p": "/api/callbacks",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "queueId",
        "t": "g"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Callbacks"
     },
     {
      "m": "GET",
      "p": "/api/callbacks/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "Callbacks"
     },
     {
      "m": "POST",
      "p": "/api/callbacks",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "number",
        "t": "s",
        "r": 1
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "scheduledFor",
        "t": "dt"
       },
       {
        "n": "note",
        "t": "s"
       }
      ],
      "perm": "Callbacks"
     },
     {
      "m": "POST",
      "p": "/api/callbacks/{id}/dial",
      "a": "Dial",
      "k": "obj",
      "h": "Call the customer back. Needs the permission to dial as well, because it spends money.",
      "b": [
       {
        "n": "fromNumberId",
        "t": "g"
       },
       {
        "n": "fromNumber",
        "t": "s"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "agentSipUsername",
        "t": "s"
       },
       {
        "n": "agentNumber",
        "t": "s"
       },
       {
        "n": "record",
        "t": "b"
       }
      ],
      "perm": "Dial"
     },
     {
      "m": "POST",
      "p": "/api/callbacks/{id}/complete",
      "a": "Complete",
      "k": "obj",
      "perm": "Callbacks"
     },
     {
      "m": "POST",
      "p": "/api/callbacks/{id}/cancel",
      "a": "Cancel",
      "k": "obj",
      "perm": "Callbacks"
     }
    ]
   },
   {
    "key": "Voicemails",
    "label": "Voicemails",
    "eps": [
     {
      "m": "GET",
      "p": "/api/voicemails",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "queueId",
        "t": "g"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Voicemail"
     },
     {
      "m": "GET",
      "p": "/api/voicemails/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "Voicemail"
     },
     {
      "m": "POST",
      "p": "/api/voicemails/{id}/heard",
      "a": "MarkHeard",
      "k": "obj",
      "perm": "Voicemail"
     },
     {
      "m": "POST",
      "p": "/api/voicemails/{id}/archive",
      "a": "Archive",
      "k": "obj",
      "perm": "Voicemail"
     },
     {
      "m": "DELETE",
      "p": "/api/voicemails/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Voicemail"
     }
    ]
   },
   {
    "key": "Dispositions",
    "label": "Dispositions",
    "eps": [
     {
      "m": "GET",
      "p": "/api/dispositions",
      "a": "List",
      "k": "list",
      "h": "Agents need the active list to tag calls; pass includeInactive=true for the settings screen.",
      "q": [
       {
        "n": "includeInactive",
        "t": "b"
       }
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/dispositions/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/dispositions",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "code",
        "t": "s",
        "r": 1
       },
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "category",
        "t": "s",
        "d": "other"
       },
       {
        "n": "isConversion",
        "t": "b"
       },
       {
        "n": "defaultValue",
        "t": "n"
       },
       {
        "n": "sortOrder",
        "t": "n"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "PUT",
      "p": "/api/dispositions/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "code",
        "t": "s",
        "r": 1
       },
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "category",
        "t": "s",
        "d": "other"
       },
       {
        "n": "isConversion",
        "t": "b"
       },
       {
        "n": "defaultValue",
        "t": "n"
       },
       {
        "n": "sortOrder",
        "t": "n"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/dispositions/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Manage"
     }
    ]
   }
  ]
 },
 {
  "key": "agents",
  "label": "Agents",
  "icon": "M9 11a3 3 0 100-6 3 3 0 000 6zM3 20c0-3.3 2.7-5 6-5s6 1.7 6 5M17 11a2.5 2.5 0 100-5M17.5 15c2.2.3 3.5 1.7 3.5 4",
  "sections": [
   {
    "key": "Agents",
    "label": "Agents",
    "eps": [
     {
      "m": "GET",
      "p": "/api/agents",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "teamId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "skillId",
        "t": "g"
       },
       {
        "n": "active",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/agents/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/agents",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "email",
        "t": "s",
        "r": 1
       },
       {
        "n": "displayName",
        "t": "s",
        "r": 1
       },
       {
        "n": "userId",
        "t": "s",
        "h": "Central-auth user id, when known. Otherwise it is linked on the agent's first sign-in through the e-mail address."
       },
       {
        "n": "extension",
        "t": "s"
       },
       {
        "n": "forwardNumber",
        "t": "s",
        "h": "Number rung when the agent has no softphone credential (E.164 or national format)."
       },
       {
        "n": "languages",
        "t": "sa"
       },
       {
        "n": "teamId",
        "t": "g"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "autoAnswer",
        "t": "b"
       },
       {
        "n": "skills",
        "t": "j",
        "h": "When set the agent's skills are replaced by this list; null leaves them unchanged."
       },
       {
        "n": "queues",
        "t": "j",
        "h": "When set the agent's queue memberships are replaced by this list; null leaves them unchanged."
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "PUT",
      "p": "/api/agents/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "email",
        "t": "s",
        "r": 1
       },
       {
        "n": "displayName",
        "t": "s",
        "r": 1
       },
       {
        "n": "userId",
        "t": "s",
        "h": "Central-auth user id, when known. Otherwise it is linked on the agent's first sign-in through the e-mail address."
       },
       {
        "n": "extension",
        "t": "s"
       },
       {
        "n": "forwardNumber",
        "t": "s",
        "h": "Number rung when the agent has no softphone credential (E.164 or national format)."
       },
       {
        "n": "languages",
        "t": "sa"
       },
       {
        "n": "teamId",
        "t": "g"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "autoAnswer",
        "t": "b"
       },
       {
        "n": "skills",
        "t": "j",
        "h": "When set the agent's skills are replaced by this list; null leaves them unchanged."
       },
       {
        "n": "queues",
        "t": "j",
        "h": "When set the agent's queue memberships are replaced by this list; null leaves them unchanged."
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/agents/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Manage"
     },
     {
      "m": "PUT",
      "p": "/api/agents/{id}/skills",
      "a": "SetSkills",
      "k": "list",
      "b": [
       {
        "n": "skills",
        "t": "j",
        "r": 1
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "PUT",
      "p": "/api/agents/{id}/queues",
      "a": "SetQueues",
      "k": "list",
      "b": [
       {
        "n": "queues",
        "t": "j",
        "r": 1
       }
      ],
      "perm": "Teams"
     },
     {
      "m": "POST",
      "p": "/api/agents/import",
      "a": "Import",
      "k": "obj",
      "h": "Creates or updates up to 500 agents by e-mail address in one call.",
      "b": [
       {
        "n": "agents",
        "t": "j",
        "r": 1
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/agents/{id}/softphone/reset",
      "a": "ResetSoftphone",
      "k": "obj",
      "h": "Replaces the agent's softphone credential (lost device, suspected leak).",
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/agents/{id}/presence",
      "a": "Presence",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/agents/{id}/stats",
      "a": "Stats",
      "k": "obj",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/agents/{id}/status-history",
      "a": "History",
      "k": "list",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "limit",
        "t": "n",
        "d": 200
       }
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/agents/performance",
      "a": "Performance",
      "k": "paged",
      "h": "Everyone's counters for a period, busiest first (leaderboard / team report).",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "teamId",
        "t": "g"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     }
    ]
   },
   {
    "key": "Supervisor",
    "label": "Live board",
    "eps": [
     {
      "m": "GET",
      "p": "/api/supervisor/agents",
      "a": "Board",
      "k": "list",
      "h": "Every active agent with status, time in status, current call and today's counters.",
      "q": [
       {
        "n": "teamId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s"
       }
      ],
      "qp": [],
      "perm": "Supervise"
     },
     {
      "m": "GET",
      "p": "/api/supervisor/summary",
      "a": "Summary",
      "k": "obj",
      "perm": "Supervise"
     },
     {
      "m": "PUT",
      "p": "/api/supervisor/agents/{id}/status",
      "a": "ForceStatus",
      "k": "obj",
      "b": [
       {
        "n": "status",
        "t": "s",
        "r": 1
       },
       {
        "n": "reason",
        "t": "s"
       },
       {
        "n": "immediate",
        "t": "b",
        "h": "Apply at once even during a call or after-call work (use for a stuck agent). Otherwise it waits like the agent's own change."
       }
      ],
      "perm": "Supervise"
     },
     {
      "m": "POST",
      "p": "/api/supervisor/agents/{id}/logout",
      "a": "ForceLogout",
      "k": "obj",
      "q": [
       {
        "n": "immediate",
        "t": "b"
       }
      ],
      "perm": "Supervise"
     }
    ]
   },
   {
    "key": "Teams",
    "label": "Teams",
    "eps": [
     {
      "m": "GET",
      "p": "/api/agent-teams",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/agent-teams/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/agent-teams",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "managerAgentId",
        "t": "g"
       }
      ],
      "perm": "Teams"
     },
     {
      "m": "PUT",
      "p": "/api/agent-teams/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "managerAgentId",
        "t": "g"
       }
      ],
      "perm": "Teams"
     },
     {
      "m": "DELETE",
      "p": "/api/agent-teams/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Teams"
     },
     {
      "m": "PUT",
      "p": "/api/agent-teams/{id}/members",
      "a": "SetMembers",
      "k": "obj",
      "b": [
       {
        "n": "agentIds",
        "t": "ga",
        "r": 1
       }
      ],
      "perm": "Teams"
     }
    ]
   },
   {
    "key": "Skills",
    "label": "Skills",
    "eps": [
     {
      "m": "GET",
      "p": "/api/agent-skills",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/agent-skills/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/agent-skills",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       }
      ],
      "perm": "Teams"
     },
     {
      "m": "PUT",
      "p": "/api/agent-skills/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       }
      ],
      "perm": "Teams"
     },
     {
      "m": "DELETE",
      "p": "/api/agent-skills/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Teams"
     }
    ]
   },
   {
    "key": "QueueMembers",
    "label": "Queue members",
    "eps": [
     {
      "m": "GET",
      "p": "/api/agent-queues/{queueId}/members",
      "a": "List",
      "k": "list",
      "perm": "View"
     },
     {
      "m": "PUT",
      "p": "/api/agent-queues/{queueId}/members",
      "a": "Set",
      "k": "list",
      "b": [
       {
        "n": "members",
        "t": "j",
        "r": 1
       }
      ],
      "perm": "Teams"
     },
     {
      "m": "POST",
      "p": "/api/agent-queues/{queueId}/members",
      "a": "Add",
      "k": "obj",
      "b": [
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "priority",
        "t": "n",
        "d": 1
       }
      ],
      "perm": "Teams"
     },
     {
      "m": "DELETE",
      "p": "/api/agent-queues/{queueId}/members/{agentId}",
      "a": "Remove",
      "k": "none",
      "perm": "Teams"
     }
    ]
   },
   {
    "key": "AgentMe",
    "label": "My agent",
    "eps": [
     {
      "m": "GET",
      "p": "/api/agents/me",
      "a": "Me",
      "k": "obj",
      "perm": "Self"
     },
     {
      "m": "GET",
      "p": "/api/agents/me/presence",
      "a": "Presence",
      "k": "obj",
      "perm": "Self"
     },
     {
      "m": "POST",
      "p": "/api/agents/me/login",
      "a": "Login",
      "k": "obj",
      "b": [
       {
        "n": "status",
        "t": "s",
        "o": [
         "available",
         "busy",
         "break"
        ],
        "h": "available | busy | break (default available)."
       }
      ],
      "perm": "Self"
     },
     {
      "m": "POST",
      "p": "/api/agents/me/logout",
      "a": "Logout",
      "k": "obj",
      "perm": "Self"
     },
     {
      "m": "PUT",
      "p": "/api/agents/me/status",
      "a": "SetStatus",
      "k": "obj",
      "b": [
       {
        "n": "status",
        "t": "s",
        "r": 1,
        "o": [
         "available",
         "busy",
         "break",
         "offline"
        ],
        "h": "available | busy | break | offline"
       },
       {
        "n": "reason",
        "t": "s"
       }
      ],
      "perm": "Self"
     },
     {
      "m": "POST",
      "p": "/api/agents/me/heartbeat",
      "a": "Heartbeat",
      "k": "obj",
      "h": "Call every 15-20 seconds while the softphone is open. The answer shows whether the server still considers the agent signed in.",
      "perm": "Self"
     },
     {
      "m": "POST",
      "p": "/api/agents/me/end-acw",
      "a": "EndAcw",
      "k": "obj",
      "perm": "Self"
     },
     {
      "m": "POST",
      "p": "/api/agents/me/decline",
      "a": "Decline",
      "k": "none",
      "h": "The softphone did not take an offered call: the agent is released for the next call at once.",
      "b": [
       {
        "n": "callId",
        "t": "g"
       }
      ],
      "perm": "Self"
     },
     {
      "m": "GET",
      "p": "/api/agents/me/softphone",
      "a": "Softphone",
      "k": "obj",
      "h": "SIP username and a short-lived token for the browser softphone (the credential is created on first use).",
      "perm": "Self"
     },
     {
      "m": "GET",
      "p": "/api/agents/me/stats",
      "a": "Stats",
      "k": "obj",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "perm": "Self"
     }
    ]
   }
  ]
 },
 {
  "key": "routing",
  "label": "Routing",
  "icon": "M5 5h5v5H5zM14 4h5v5h-5zM14 15h5v5h-5zM10 7.5h2V17.5h2M12 6.5h2",
  "sections": [
   {
    "key": "Queues",
    "label": "Queues",
    "eps": [
     {
      "m": "GET",
      "p": "/api/queues",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/queues/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/queues",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "strategy",
        "t": "s",
        "o": [
         "ring_all",
         "round_robin",
         "longest_idle",
         "skills"
        ],
        "d": "ring_all",
        "h": "ring_all | round_robin | longest_idle | skills"
       },
       {
        "n": "maxWaitSeconds",
        "t": "n",
        "d": 120
       },
       {
        "n": "agentRingSeconds",
        "t": "n",
        "d": 20
       },
       {
        "n": "maxQueueSize",
        "t": "n",
        "d": 50
       },
       {
        "n": "announceWaitTime",
        "t": "b"
       },
       {
        "n": "announcePosition",
        "t": "b"
       },
       {
        "n": "offerCallback",
        "t": "b"
       },
       {
        "n": "musicUrl",
        "t": "s"
       },
       {
        "n": "overflowQueueId",
        "t": "g"
       },
       {
        "n": "overflowAction",
        "t": "s",
        "o": [
         "voicemail",
         "forward",
         "hangup",
         "queue",
         "callback"
        ],
        "h": "voicemail | forward | hangup | queue | callback"
       },
       {
        "n": "overflowForwardTo",
        "t": "s"
       },
       {
        "n": "serviceLevelSeconds",
        "t": "n",
        "d": 20
       },
       {
        "n": "wrapupSeconds",
        "t": "n",
        "d": 30
       },
       {
        "n": "requiredSkills",
        "t": "sa"
       },
       {
        "n": "language",
        "t": "s"
       },
       {
        "n": "recordingMode",
        "t": "s",
        "o": [
         "inherit",
         "always",
         "never"
        ],
        "d": "inherit",
        "h": "inherit | always | never"
       },
       {
        "n": "status",
        "t": "s",
        "o": [
         "active",
         "paused"
        ],
        "d": "active",
        "h": "active | paused"
       }
      ],
      "perm": "Queues"
     },
     {
      "m": "PUT",
      "p": "/api/queues/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "strategy",
        "t": "s",
        "o": [
         "ring_all",
         "round_robin",
         "longest_idle",
         "skills"
        ],
        "d": "ring_all",
        "h": "ring_all | round_robin | longest_idle | skills"
       },
       {
        "n": "maxWaitSeconds",
        "t": "n",
        "d": 120
       },
       {
        "n": "agentRingSeconds",
        "t": "n",
        "d": 20
       },
       {
        "n": "maxQueueSize",
        "t": "n",
        "d": 50
       },
       {
        "n": "announceWaitTime",
        "t": "b"
       },
       {
        "n": "announcePosition",
        "t": "b"
       },
       {
        "n": "offerCallback",
        "t": "b"
       },
       {
        "n": "musicUrl",
        "t": "s"
       },
       {
        "n": "overflowQueueId",
        "t": "g"
       },
       {
        "n": "overflowAction",
        "t": "s",
        "o": [
         "voicemail",
         "forward",
         "hangup",
         "queue",
         "callback"
        ],
        "h": "voicemail | forward | hangup | queue | callback"
       },
       {
        "n": "overflowForwardTo",
        "t": "s"
       },
       {
        "n": "serviceLevelSeconds",
        "t": "n",
        "d": 20
       },
       {
        "n": "wrapupSeconds",
        "t": "n",
        "d": 30
       },
       {
        "n": "requiredSkills",
        "t": "sa"
       },
       {
        "n": "language",
        "t": "s"
       },
       {
        "n": "recordingMode",
        "t": "s",
        "o": [
         "inherit",
         "always",
         "never"
        ],
        "d": "inherit",
        "h": "inherit | always | never"
       },
       {
        "n": "status",
        "t": "s",
        "o": [
         "active",
         "paused"
        ],
        "d": "active",
        "h": "active | paused"
       }
      ],
      "perm": "Queues"
     },
     {
      "m": "DELETE",
      "p": "/api/queues/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Queues"
     }
    ]
   },
   {
    "key": "Rules",
    "label": "Routing rules",
    "eps": [
     {
      "m": "GET",
      "p": "/api/routing/rules",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "enabled",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/routing/rules/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/routing/rules",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "eventType",
        "t": "s",
        "r": 1
       },
       {
        "n": "action",
        "t": "s",
        "r": 1
       },
       {
        "n": "connectionId",
        "t": "g"
       },
       {
        "n": "filters",
        "t": "j",
        "h": "[{ \"field\": \"durationSeconds\", \"op\": \"gte\", \"value\": 30 }] evaluated against the event payload."
       },
       {
        "n": "config",
        "t": "j"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "delaySeconds",
        "t": "n"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "PUT",
      "p": "/api/routing/rules/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "eventType",
        "t": "s",
        "r": 1
       },
       {
        "n": "action",
        "t": "s",
        "r": 1
       },
       {
        "n": "connectionId",
        "t": "g"
       },
       {
        "n": "filters",
        "t": "j",
        "h": "[{ \"field\": \"durationSeconds\", \"op\": \"gte\", \"value\": 30 }] evaluated against the event payload."
       },
       {
        "n": "config",
        "t": "j"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "delaySeconds",
        "t": "n"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/routing/rules/{id}/enable",
      "a": "Enable",
      "k": "obj",
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/routing/rules/{id}/disable",
      "a": "Disable",
      "k": "obj",
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/routing/rules/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/routing/rules/reorder",
      "a": "Reorder",
      "k": "list",
      "b": [
       {
        "n": "ruleIds",
        "t": "ga",
        "r": 1
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/routing/simulate",
      "a": "Simulate",
      "k": "obj",
      "h": "Dry run: what would happen to a call with these properties, and why. Nothing is stored.",
      "b": [
       {
        "n": "request",
        "t": "j",
        "r": 1
       }
      ],
      "perm": "Simulate"
     }
    ]
   },
   {
    "key": "Schedules",
    "label": "Schedules",
    "eps": [
     {
      "m": "GET",
      "p": "/api/routing/schedules",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/routing/schedules/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/routing/schedules/{id}/status",
      "a": "Status",
      "k": "obj",
      "q": [
       {
        "n": "at",
        "t": "dt"
       }
      ],
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/routing/schedules",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "definitionId",
        "t": "g",
        "r": 1
       },
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "cronExpression",
        "t": "s",
        "r": 1,
        "d": "0 8 * * 1"
       },
       {
        "n": "timezone",
        "t": "s",
        "d": "UTC"
       },
       {
        "n": "format",
        "t": "s",
        "d": "csv"
       },
       {
        "n": "deliveryChannel",
        "t": "s",
        "d": "email"
       },
       {
        "n": "recipients",
        "t": "s"
       },
       {
        "n": "integrationConnectionId",
        "t": "g"
       },
       {
        "n": "includeLink",
        "t": "b",
        "d": true
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "PUT",
      "p": "/api/routing/schedules/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "definitionId",
        "t": "g",
        "r": 1
       },
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "cronExpression",
        "t": "s",
        "r": 1,
        "d": "0 8 * * 1"
       },
       {
        "n": "timezone",
        "t": "s",
        "d": "UTC"
       },
       {
        "n": "format",
        "t": "s",
        "d": "csv"
       },
       {
        "n": "deliveryChannel",
        "t": "s",
        "d": "email"
       },
       {
        "n": "recipients",
        "t": "s"
       },
       {
        "n": "integrationConnectionId",
        "t": "g"
       },
       {
        "n": "includeLink",
        "t": "b",
        "d": true
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/routing/schedules/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/routing/holiday-calendars",
      "a": "ListCalendars",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/routing/holiday-calendars/{id}",
      "a": "GetCalendar",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/routing/holiday-calendars",
      "a": "CreateCalendar",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "country",
        "t": "s"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "PUT",
      "p": "/api/routing/holiday-calendars/{id}",
      "a": "UpdateCalendar",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "country",
        "t": "s"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/routing/holiday-calendars/{id}",
      "a": "DeleteCalendar",
      "k": "none",
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/routing/holiday-calendars/{id}/holidays",
      "a": "AddHoliday",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "date",
        "t": "dt"
       },
       {
        "n": "recurring",
        "t": "b",
        "h": "Repeats every year on the same month and day."
       },
       {
        "n": "closed",
        "t": "b",
        "d": true,
        "h": "True = closed all day; false = open with the special hours below."
       },
       {
        "n": "specialFrom",
        "t": "s"
       },
       {
        "n": "specialTo",
        "t": "s"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "PUT",
      "p": "/api/routing/holiday-calendars/{id}/holidays/{holidayId}",
      "a": "UpdateHoliday",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "date",
        "t": "dt"
       },
       {
        "n": "recurring",
        "t": "b",
        "h": "Repeats every year on the same month and day."
       },
       {
        "n": "closed",
        "t": "b",
        "d": true,
        "h": "True = closed all day; false = open with the special hours below."
       },
       {
        "n": "specialFrom",
        "t": "s"
       },
       {
        "n": "specialTo",
        "t": "s"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/routing/holiday-calendars/{id}/holidays/{holidayId}",
      "a": "DeleteHoliday",
      "k": "none",
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/routing/holiday-calendars/{id}/holidays/import",
      "a": "ImportHolidays",
      "k": "obj",
      "b": [
       {
        "n": "holidays",
        "t": "j",
        "r": 1
       }
      ],
      "perm": "Manage"
     }
    ]
   },
   {
    "key": "IvrFlows",
    "label": "IVR flows",
    "eps": [
     {
      "m": "GET",
      "p": "/api/routing/ivr-flows",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/routing/ivr-flows/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/routing/ivr-flows",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "defaultLanguage",
        "t": "s",
        "d": "en"
       },
       {
        "n": "startNodeKey",
        "t": "s",
        "h": "Optional starting content for the first draft."
       },
       {
        "n": "nodes",
        "t": "j"
       }
      ],
      "perm": "Ivr"
     },
     {
      "m": "PUT",
      "p": "/api/routing/ivr-flows/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "defaultLanguage",
        "t": "s",
        "d": "en"
       }
      ],
      "perm": "Ivr"
     },
     {
      "m": "DELETE",
      "p": "/api/routing/ivr-flows/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Ivr"
     },
     {
      "m": "GET",
      "p": "/api/routing/ivr-flows/{id}/versions",
      "a": "Versions",
      "k": "list",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/routing/ivr-flows/{id}/versions/{versionId}",
      "a": "GetVersion",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "PUT",
      "p": "/api/routing/ivr-flows/{id}/draft",
      "a": "SaveDraft",
      "k": "obj",
      "b": [
       {
        "n": "startNodeKey",
        "t": "s"
       },
       {
        "n": "nodes",
        "t": "j",
        "r": 1
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "Ivr"
     },
     {
      "m": "DELETE",
      "p": "/api/routing/ivr-flows/{id}/draft",
      "a": "DiscardDraft",
      "k": "none",
      "perm": "Ivr"
     },
     {
      "m": "POST",
      "p": "/api/routing/ivr-flows/{id}/validate",
      "a": "Validate",
      "k": "obj",
      "q": [
       {
        "n": "versionId",
        "t": "g"
       }
      ],
      "perm": "Ivr"
     },
     {
      "m": "POST",
      "p": "/api/routing/ivr-flows/{id}/publish",
      "a": "Publish",
      "k": "obj",
      "perm": "Ivr"
     },
     {
      "m": "POST",
      "p": "/api/routing/ivr-flows/{id}/versions/{versionId}/rollback",
      "a": "Rollback",
      "k": "obj",
      "perm": "Ivr"
     },
     {
      "m": "POST",
      "p": "/api/routing/ivr-flows/{id}/test",
      "a": "Test",
      "k": "obj",
      "h": "Walks the flow with scripted caller input and returns every prompt and decision. Nothing is stored.",
      "b": [
       {
        "n": "versionId",
        "t": "g",
        "h": "Version to walk; null = the draft (or the latest version when there is no draft)."
       },
       {
        "n": "inputs",
        "t": "sa",
        "h": "Inputs the pretend caller gives, in order: DTMF digits or spoken text. Use \"\" for silence."
       },
       {
        "n": "language",
        "t": "s"
       },
       {
        "n": "callerNumber",
        "t": "s",
        "d": "+2348031234567"
       },
       {
        "n": "calledNumber",
        "t": "s",
        "d": "+2349000000000"
       },
       {
        "n": "executeHttp",
        "t": "b",
        "h": "Really call http_request nodes (tenant URLs). Off by default."
       },
       {
        "n": "maxSteps",
        "t": "n",
        "d": 30
       }
      ],
      "perm": "Ivr"
     }
    ]
   },
   {
    "key": "CallerLists",
    "label": "Caller lists",
    "eps": [
     {
      "m": "GET",
      "p": "/api/routing/lists",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "kind",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/routing/lists/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/routing/lists",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "kind",
        "t": "s",
        "r": 1,
        "o": [
         "vip",
         "block",
         "allow"
        ],
        "d": "vip",
        "h": "vip | block | allow"
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "enabled",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Lists"
     },
     {
      "m": "PUT",
      "p": "/api/routing/lists/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "kind",
        "t": "s",
        "r": 1,
        "o": [
         "vip",
         "block",
         "allow"
        ],
        "d": "vip",
        "h": "vip | block | allow"
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "enabled",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Lists"
     },
     {
      "m": "DELETE",
      "p": "/api/routing/lists/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Lists"
     },
     {
      "m": "GET",
      "p": "/api/routing/lists/{id}/entries",
      "a": "Entries",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/routing/lists/{id}/entries",
      "a": "AddEntry",
      "k": "obj",
      "b": [
       {
        "n": "value",
        "t": "s",
        "r": 1,
        "h": "A phone number, or an E.164 prefix ending with * (for example +23480*)."
       },
       {
        "n": "note",
        "t": "s"
       }
      ],
      "perm": "Lists"
     },
     {
      "m": "DELETE",
      "p": "/api/routing/lists/{id}/entries/{entryId}",
      "a": "DeleteEntry",
      "k": "none",
      "perm": "Lists"
     },
     {
      "m": "POST",
      "p": "/api/routing/lists/{id}/entries/import",
      "a": "Import",
      "k": "obj",
      "b": [
       {
        "n": "lines",
        "t": "sa",
        "r": 1,
        "h": "One entry per item. Items may be \"number\" or \"number,note\"; prefixes end with *."
       },
       {
        "n": "replace",
        "t": "b",
        "h": "When true the list is emptied first."
       }
      ],
      "perm": "Lists"
     },
     {
      "m": "GET",
      "p": "/api/routing/lists/check",
      "a": "Check",
      "k": "obj",
      "h": "Which lists contain this number?",
      "q": [
       {
        "n": "number",
        "t": "s"
       }
      ],
      "perm": "View"
     }
    ]
   }
  ]
 },
 {
  "key": "numbers",
  "label": "Numbers",
  "icon": "M9 4L7 20M17 4l-2 16M4 9h16M3 15h16",
  "sections": [
   {
    "key": "Numbers",
    "label": "Numbers",
    "eps": [
     {
      "m": "GET",
      "p": "/api/numbers/available",
      "a": "Available",
      "k": "list",
      "h": "Search Telnyx inventory for numbers that can be bought.",
      "q": [
       {
        "n": "country",
        "t": "s",
        "d": "NG"
       },
       {
        "n": "type",
        "t": "s"
       },
       {
        "n": "areaCode",
        "t": "s"
       },
       {
        "n": "contains",
        "t": "s"
       },
       {
        "n": "limit",
        "t": "n",
        "d": 20
       }
      ],
      "perm": "Provision"
     },
     {
      "m": "GET",
      "p": "/api/numbers",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "numberType",
        "t": "s"
       },
       {
        "n": "country",
        "t": "s"
       },
       {
        "n": "poolId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "unassigned",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/numbers/inventory",
      "a": "Inventory",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/numbers/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/numbers/{id}/allocations",
      "a": "Allocations",
      "k": "list",
      "q": [
       {
        "n": "take",
        "t": "n",
        "d": 100
       }
      ],
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/numbers/provision",
      "a": "Provision",
      "k": "list",
      "h": "Buy numbers from Telnyx. Spends money, so it has its own permission.",
      "b": [
       {
        "n": "numbers",
        "t": "sa",
        "r": 1
       },
       {
        "n": "poolId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "brandId",
        "t": "g"
       },
       {
        "n": "label",
        "t": "s"
       },
       {
        "n": "forwardTo",
        "t": "s"
       },
       {
        "n": "monthlyCost",
        "t": "n"
       },
       {
        "n": "currency",
        "t": "s"
       }
      ],
      "perm": "Provision"
     },
     {
      "m": "POST",
      "p": "/api/numbers/import",
      "a": "Import",
      "k": "obj",
      "h": "Register a number that already exists in the Telnyx account.",
      "b": [
       {
        "n": "number",
        "t": "s",
        "r": 1
       },
       {
        "n": "poolId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "brandId",
        "t": "g"
       },
       {
        "n": "label",
        "t": "s"
       },
       {
        "n": "forwardTo",
        "t": "s"
       }
      ],
      "perm": "Provision"
     },
     {
      "m": "GET",
      "p": "/api/numbers/unregistered",
      "a": "Unregistered",
      "k": "list",
      "h": "Numbers owned in Telnyx but not yet registered here.",
      "perm": "Provision"
     },
     {
      "m": "PUT",
      "p": "/api/numbers/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "label",
        "t": "s"
       },
       {
        "n": "forwardTo",
        "t": "s"
       },
       {
        "n": "poolId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "brandId",
        "t": "g"
       },
       {
        "n": "routingTargetType",
        "t": "s"
       },
       {
        "n": "routingTargetId",
        "t": "g"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/numbers/{id}/quarantine",
      "a": "Quarantine",
      "k": "obj",
      "b": [
       {
        "n": "days",
        "t": "n",
        "d": 30
       },
       {
        "n": "reason",
        "t": "s"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/numbers/{id}/reactivate",
      "a": "Reactivate",
      "k": "obj",
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/numbers/{id}/release",
      "a": "Release",
      "k": "obj",
      "h": "Give the number back to Telnyx. Use force=true to release it even while visitors still hold it.",
      "q": [
       {
        "n": "force",
        "t": "b",
        "d": false
       }
      ],
      "perm": "Provision"
     }
    ]
   },
   {
    "key": "Pools",
    "label": "Number pools",
    "eps": [
     {
      "m": "GET",
      "p": "/api/number-pools",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/number-pools/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/number-pools",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "brandId",
        "t": "g"
       },
       {
        "n": "strategy",
        "t": "s",
        "d": "least_recent"
       },
       {
        "n": "stickinessSeconds",
        "t": "n",
        "d": 1800
       },
       {
        "n": "minSize",
        "t": "n"
       },
       {
        "n": "maxSize",
        "t": "n",
        "d": 100
       },
       {
        "n": "autoProvision",
        "t": "b"
       },
       {
        "n": "country",
        "t": "s",
        "r": 1,
        "d": "NG"
       },
       {
        "n": "numberType",
        "t": "s",
        "d": "local"
       },
       {
        "n": "nationalDestinationCode",
        "t": "s"
       },
       {
        "n": "status",
        "t": "s",
        "d": "active"
       },
       {
        "n": "defaultNumberId",
        "t": "g"
       },
       {
        "n": "lowThresholdPercent",
        "t": "n",
        "d": 20
       }
      ],
      "perm": "Pools"
     },
     {
      "m": "PUT",
      "p": "/api/number-pools/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "brandId",
        "t": "g"
       },
       {
        "n": "strategy",
        "t": "s",
        "d": "least_recent"
       },
       {
        "n": "stickinessSeconds",
        "t": "n",
        "d": 1800
       },
       {
        "n": "minSize",
        "t": "n"
       },
       {
        "n": "maxSize",
        "t": "n",
        "d": 100
       },
       {
        "n": "autoProvision",
        "t": "b"
       },
       {
        "n": "country",
        "t": "s",
        "r": 1,
        "d": "NG"
       },
       {
        "n": "numberType",
        "t": "s",
        "d": "local"
       },
       {
        "n": "nationalDestinationCode",
        "t": "s"
       },
       {
        "n": "status",
        "t": "s",
        "d": "active"
       },
       {
        "n": "defaultNumberId",
        "t": "g"
       },
       {
        "n": "lowThresholdPercent",
        "t": "n",
        "d": 20
       }
      ],
      "perm": "Pools"
     },
     {
      "m": "DELETE",
      "p": "/api/number-pools/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Pools"
     },
     {
      "m": "GET",
      "p": "/api/number-pools/{id}/numbers",
      "a": "Numbers",
      "k": "list",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/number-pools/{id}/numbers",
      "a": "AddNumbers",
      "k": "list",
      "b": [
       {
        "n": "numberIds",
        "t": "ga",
        "r": 1
       }
      ],
      "perm": "Pools"
     },
     {
      "m": "DELETE",
      "p": "/api/number-pools/{id}/numbers/{numberId}",
      "a": "RemoveNumber",
      "k": "none",
      "perm": "Pools"
     },
     {
      "m": "GET",
      "p": "/api/number-pools/{id}/stats",
      "a": "Stats",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/number-pools/{id}/health",
      "a": "Health",
      "k": "list",
      "q": [
       {
        "n": "hours",
        "t": "n",
        "d": 24
       }
      ],
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/number-pools/{id}/provision",
      "a": "Provision",
      "k": "list",
      "h": "Buy more numbers for the pool from Telnyx using the pool's country, type and area code.",
      "q": [
       {
        "n": "count",
        "t": "n",
        "d": 5
       }
      ],
      "perm": "Provision"
     }
    ]
   },
   {
    "key": "PortRequests",
    "label": "Port requests",
    "eps": [
     {
      "m": "GET",
      "p": "/api/number-ports",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/number-ports/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/number-ports",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "numbers",
        "t": "sa",
        "r": 1
       },
       {
        "n": "status",
        "t": "s",
        "d": "draft"
       },
       {
        "n": "losingCarrier",
        "t": "s"
       },
       {
        "n": "accountNumber",
        "t": "s"
       },
       {
        "n": "requestedAt",
        "t": "dt"
       },
       {
        "n": "targetDate",
        "t": "dt"
       },
       {
        "n": "completedAt",
        "t": "dt"
       },
       {
        "n": "providerReference",
        "t": "s"
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "PUT",
      "p": "/api/number-ports/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "numbers",
        "t": "sa",
        "r": 1
       },
       {
        "n": "status",
        "t": "s",
        "d": "draft"
       },
       {
        "n": "losingCarrier",
        "t": "s"
       },
       {
        "n": "accountNumber",
        "t": "s"
       },
       {
        "n": "requestedAt",
        "t": "dt"
       },
       {
        "n": "targetDate",
        "t": "dt"
       },
       {
        "n": "completedAt",
        "t": "dt"
       },
       {
        "n": "providerReference",
        "t": "s"
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/number-ports/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Manage"
     }
    ]
   }
  ]
 },
 {
  "key": "campaigns",
  "label": "Campaigns",
  "icon": "M3 11v3l12 5V6zM15 8.5c3 0 5 1.5 5 3.5s-2 3.5-5 3.5",
  "sections": [
   {
    "key": "Campaigns",
    "label": "Campaigns",
    "eps": [
     {
      "m": "GET",
      "p": "/api/campaigns",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "brandId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "channel",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "CampaignsView"
     },
     {
      "m": "GET",
      "p": "/api/campaigns/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "CampaignsView"
     },
     {
      "m": "POST",
      "p": "/api/campaigns",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "brandId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "channel",
        "t": "s"
       },
       {
        "n": "status",
        "t": "s",
        "d": "active"
       },
       {
        "n": "budget",
        "t": "n"
       },
       {
        "n": "currency",
        "t": "s",
        "d": "USD"
       },
       {
        "n": "startDate",
        "t": "dt"
       },
       {
        "n": "endDate",
        "t": "dt"
       },
       {
        "n": "defaultPoolId",
        "t": "g"
       },
       {
        "n": "trackingTemplate",
        "t": "s"
       },
       {
        "n": "costModel",
        "t": "s",
        "d": "spend"
       },
       {
        "n": "costPerCall",
        "t": "n"
       },
       {
        "n": "attributionModel",
        "t": "s"
       },
       {
        "n": "lookbackDays",
        "t": "n"
       },
       {
        "n": "utmCampaign",
        "t": "s"
       }
      ],
      "perm": "CampaignsManage"
     },
     {
      "m": "PUT",
      "p": "/api/campaigns/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "brandId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "channel",
        "t": "s"
       },
       {
        "n": "status",
        "t": "s",
        "d": "active"
       },
       {
        "n": "budget",
        "t": "n"
       },
       {
        "n": "currency",
        "t": "s",
        "d": "USD"
       },
       {
        "n": "startDate",
        "t": "dt"
       },
       {
        "n": "endDate",
        "t": "dt"
       },
       {
        "n": "defaultPoolId",
        "t": "g"
       },
       {
        "n": "trackingTemplate",
        "t": "s"
       },
       {
        "n": "costModel",
        "t": "s",
        "d": "spend"
       },
       {
        "n": "costPerCall",
        "t": "n"
       },
       {
        "n": "attributionModel",
        "t": "s"
       },
       {
        "n": "lookbackDays",
        "t": "n"
       },
       {
        "n": "utmCampaign",
        "t": "s"
       }
      ],
      "perm": "CampaignsManage"
     },
     {
      "m": "DELETE",
      "p": "/api/campaigns/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "CampaignsManage"
     },
     {
      "m": "GET",
      "p": "/api/campaigns/{id}/keywords",
      "a": "Keywords",
      "k": "list",
      "perm": "CampaignsView"
     },
     {
      "m": "POST",
      "p": "/api/campaigns/{id}/keywords",
      "a": "AddKeyword",
      "k": "obj",
      "b": [
       {
        "n": "keyword",
        "t": "s",
        "r": 1
       },
       {
        "n": "matchType",
        "t": "s",
        "d": "phrase"
       },
       {
        "n": "poolId",
        "t": "g"
       },
       {
        "n": "cpc",
        "t": "n"
       }
      ],
      "perm": "CampaignsManage"
     },
     {
      "m": "PUT",
      "p": "/api/campaigns/{id}/keywords/{keywordId}",
      "a": "UpdateKeyword",
      "k": "obj",
      "b": [
       {
        "n": "keyword",
        "t": "s",
        "r": 1
       },
       {
        "n": "matchType",
        "t": "s",
        "d": "phrase"
       },
       {
        "n": "poolId",
        "t": "g"
       },
       {
        "n": "cpc",
        "t": "n"
       }
      ],
      "perm": "CampaignsManage"
     },
     {
      "m": "DELETE",
      "p": "/api/campaigns/{id}/keywords/{keywordId}",
      "a": "DeleteKeyword",
      "k": "none",
      "perm": "CampaignsManage"
     },
     {
      "m": "GET",
      "p": "/api/campaigns/{id}/spend",
      "a": "Spend",
      "k": "list",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "perm": "CampaignsView"
     },
     {
      "m": "PUT",
      "p": "/api/campaigns/{id}/spend",
      "a": "UpsertSpend",
      "k": "obj",
      "b": [
       {
        "n": "date",
        "t": "dt",
        "r": 1
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "channel",
        "t": "s"
       },
       {
        "n": "amount",
        "t": "n"
       },
       {
        "n": "currency",
        "t": "s",
        "r": 1,
        "d": "USD"
       },
       {
        "n": "clicks",
        "t": "n"
       },
       {
        "n": "impressions",
        "t": "n"
       },
       {
        "n": "note",
        "t": "s"
       },
       {
        "n": "externalRef",
        "t": "s"
       }
      ],
      "perm": "CampaignsManage"
     },
     {
      "m": "POST",
      "p": "/api/campaigns/{id}/spend/import",
      "a": "ImportSpend",
      "k": "obj",
      "h": "Body: text/csv with the columns date, amount, currency, clicks, impressions.",
      "perm": "CampaignsManage"
     }
    ]
   },
   {
    "key": "Sources",
    "label": "Sources",
    "eps": [
     {
      "m": "GET",
      "p": "/api/sources",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "CampaignsView"
     },
     {
      "m": "GET",
      "p": "/api/sources/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "CampaignsView"
     },
     {
      "m": "POST",
      "p": "/api/sources",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "channelType",
        "t": "s",
        "r": 1
       },
       {
        "n": "isPaid",
        "t": "b"
       },
       {
        "n": "clickIdType",
        "t": "s"
       },
       {
        "n": "utmSourcePattern",
        "t": "s"
       },
       {
        "n": "utmMediumPattern",
        "t": "s"
       },
       {
        "n": "referrerPattern",
        "t": "s"
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "status",
        "t": "s",
        "d": "active"
       }
      ],
      "perm": "CampaignsManage"
     },
     {
      "m": "PUT",
      "p": "/api/sources/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "channelType",
        "t": "s",
        "r": 1
       },
       {
        "n": "isPaid",
        "t": "b"
       },
       {
        "n": "clickIdType",
        "t": "s"
       },
       {
        "n": "utmSourcePattern",
        "t": "s"
       },
       {
        "n": "utmMediumPattern",
        "t": "s"
       },
       {
        "n": "referrerPattern",
        "t": "s"
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "status",
        "t": "s",
        "d": "active"
       }
      ],
      "perm": "CampaignsManage"
     },
     {
      "m": "DELETE",
      "p": "/api/sources/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "CampaignsManage"
     }
    ]
   },
   {
    "key": "Brands",
    "label": "Brands",
    "eps": [
     {
      "m": "GET",
      "p": "/api/brands",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "CampaignsView"
     },
     {
      "m": "GET",
      "p": "/api/brands/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "CampaignsView"
     },
     {
      "m": "POST",
      "p": "/api/brands",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "website",
        "t": "s"
       },
       {
        "n": "status",
        "t": "s",
        "d": "active"
       }
      ],
      "perm": "CampaignsManage"
     },
     {
      "m": "PUT",
      "p": "/api/brands/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "website",
        "t": "s"
       },
       {
        "n": "status",
        "t": "s",
        "d": "active"
       }
      ],
      "perm": "CampaignsManage"
     },
     {
      "m": "DELETE",
      "p": "/api/brands/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "CampaignsManage"
     }
    ]
   },
   {
    "key": "LandingPages",
    "label": "Landing pages",
    "eps": [
     {
      "m": "GET",
      "p": "/api/landing-pages",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "campaignId",
        "t": "g"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "CampaignsView"
     },
     {
      "m": "GET",
      "p": "/api/landing-pages/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "CampaignsView"
     },
     {
      "m": "POST",
      "p": "/api/landing-pages",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "urlPattern",
        "t": "s",
        "r": 1
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "defaultPoolId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s",
        "d": "active"
       }
      ],
      "perm": "CampaignsManage"
     },
     {
      "m": "PUT",
      "p": "/api/landing-pages/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "urlPattern",
        "t": "s",
        "r": 1
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "defaultPoolId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s",
        "d": "active"
       }
      ],
      "perm": "CampaignsManage"
     },
     {
      "m": "DELETE",
      "p": "/api/landing-pages/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "CampaignsManage"
     }
    ]
   },
   {
    "key": "TrackingSites",
    "label": "Tracking sites",
    "eps": [
     {
      "m": "GET",
      "p": "/api/tracking-sites",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/tracking-sites/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/tracking-sites",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "domains",
        "t": "s"
       },
       {
        "n": "allowedOrigins",
        "t": "s"
       },
       {
        "n": "defaultPoolId",
        "t": "g"
       },
       {
        "n": "defaultNumber",
        "t": "s"
       },
       {
        "n": "numberSelector",
        "t": "s"
       },
       {
        "n": "sessionTimeoutSeconds",
        "t": "n",
        "d": 1800
       },
       {
        "n": "cookieDays",
        "t": "n",
        "d": 90
       },
       {
        "n": "cookieDomain",
        "t": "s"
       },
       {
        "n": "useCookies",
        "t": "b",
        "d": true
       },
       {
        "n": "stitchingEnabled",
        "t": "b"
       },
       {
        "n": "respectDnt",
        "t": "b",
        "d": true
       },
       {
        "n": "status",
        "t": "s",
        "d": "active"
       }
      ],
      "perm": "TrackingManage"
     },
     {
      "m": "PUT",
      "p": "/api/tracking-sites/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "domains",
        "t": "s"
       },
       {
        "n": "allowedOrigins",
        "t": "s"
       },
       {
        "n": "defaultPoolId",
        "t": "g"
       },
       {
        "n": "defaultNumber",
        "t": "s"
       },
       {
        "n": "numberSelector",
        "t": "s"
       },
       {
        "n": "sessionTimeoutSeconds",
        "t": "n",
        "d": 1800
       },
       {
        "n": "cookieDays",
        "t": "n",
        "d": 90
       },
       {
        "n": "cookieDomain",
        "t": "s"
       },
       {
        "n": "useCookies",
        "t": "b",
        "d": true
       },
       {
        "n": "stitchingEnabled",
        "t": "b"
       },
       {
        "n": "respectDnt",
        "t": "b",
        "d": true
       },
       {
        "n": "status",
        "t": "s",
        "d": "active"
       }
      ],
      "perm": "TrackingManage"
     },
     {
      "m": "DELETE",
      "p": "/api/tracking-sites/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "TrackingManage"
     },
     {
      "m": "GET",
      "p": "/api/tracking-sites/{id}/snippet",
      "a": "Snippet",
      "k": "obj",
      "h": "The script tag to paste into the website.",
      "perm": "TrackingManage"
     },
     {
      "m": "POST",
      "p": "/api/tracking-sites/{id}/rotate-key",
      "a": "RotateKey",
      "k": "obj",
      "h": "Issues a new tracking key; the old snippet stops working.",
      "perm": "TrackingManage"
     },
     {
      "m": "GET",
      "p": "/api/tracking-sites/{id}/rules",
      "a": "Rules",
      "k": "list",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/tracking-sites/{id}/rules",
      "a": "CreateRule",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "poolId",
        "t": "g",
        "r": 1
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "channelType",
        "t": "s"
       },
       {
        "n": "landingPagePattern",
        "t": "s"
       },
       {
        "n": "keyword",
        "t": "s"
       },
       {
        "n": "utmCampaign",
        "t": "s"
       },
       {
        "n": "utmMedium",
        "t": "s"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "TrackingManage"
     },
     {
      "m": "PUT",
      "p": "/api/tracking-sites/{id}/rules/{ruleId}",
      "a": "UpdateRule",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "poolId",
        "t": "g",
        "r": 1
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "channelType",
        "t": "s"
       },
       {
        "n": "landingPagePattern",
        "t": "s"
       },
       {
        "n": "keyword",
        "t": "s"
       },
       {
        "n": "utmCampaign",
        "t": "s"
       },
       {
        "n": "utmMedium",
        "t": "s"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "TrackingManage"
     },
     {
      "m": "DELETE",
      "p": "/api/tracking-sites/{id}/rules/{ruleId}",
      "a": "DeleteRule",
      "k": "none",
      "perm": "TrackingManage"
     }
    ]
   },
   {
    "key": "Conversions",
    "label": "Conversions",
    "eps": [
     {
      "m": "GET",
      "p": "/api/conversions",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "type",
        "t": "s"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "channel",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "uploadStatus",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/conversions/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/conversions",
      "a": "Create",
      "k": "obj",
      "h": "Reports a conversion (CRM, e-commerce, back office). Retry safe through the Idempotency-Key header and the external reference.",
      "b": [
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "callerNumber",
        "t": "s",
        "h": "Used to find the call when CallId is not known (CRM write-back): the most recent attributed call of this caller."
       },
       {
        "n": "email",
        "t": "s"
       },
       {
        "n": "type",
        "t": "s",
        "r": 1
       },
       {
        "n": "value",
        "t": "n"
       },
       {
        "n": "currency",
        "t": "s",
        "d": "USD"
       },
       {
        "n": "occurredAt",
        "t": "dt"
       },
       {
        "n": "externalRef",
        "t": "s",
        "h": "The CRM's own id (deal, opportunity). Makes the call safe to retry and lets the value be corrected later."
       },
       {
        "n": "note",
        "t": "s"
       }
      ],
      "perm": "ConversionsManage"
     },
     {
      "m": "POST",
      "p": "/api/conversions/import",
      "a": "Import",
      "k": "obj",
      "b": [
       {
        "n": "rows",
        "t": "j",
        "r": 1
       }
      ],
      "perm": "ConversionsManage"
     },
     {
      "m": "POST",
      "p": "/api/conversions/import/csv",
      "a": "ImportCsv",
      "k": "obj",
      "h": "Body: text/csv with the header row type,value,currency,occurred_at,call_id,caller_number,email,external_ref,note.",
      "perm": "ConversionsManage"
     },
     {
      "m": "DELETE",
      "p": "/api/conversions/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "ConversionsManage"
     },
     {
      "m": "POST",
      "p": "/api/conversions/{id}/retry-uploads",
      "a": "RetryUploads",
      "k": "obj",
      "h": "Puts failed or skipped ad platform uploads back in the queue.",
      "perm": "ConversionsManage"
     },
     {
      "m": "GET",
      "p": "/api/conversions/export",
      "a": "Export",
      "k": "file",
      "h": "CSV export. Caller numbers are masked to the last four digits.",
      "q": [
       {
        "n": "type",
        "t": "s"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "channel",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "uploadStatus",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Export"
     }
    ]
   },
   {
    "key": "Attribution",
    "label": "Attribution",
    "eps": [
     {
      "m": "GET",
      "p": "/api/attribution/settings",
      "a": "GetSettings",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "PUT",
      "p": "/api/attribution/settings",
      "a": "UpdateSettings",
      "k": "obj",
      "b": [
       {
        "n": "defaultModel",
        "t": "s",
        "r": 1
       },
       {
        "n": "lookbackDays",
        "t": "n",
        "d": 30
       },
       {
        "n": "timeDecayHalfLifeDays",
        "t": "n",
        "d": 7
       },
       {
        "n": "positionFirstPercent",
        "t": "n",
        "d": 40
       },
       {
        "n": "positionLastPercent",
        "t": "n",
        "d": 40
       },
       {
        "n": "sessionRetentionDays",
        "t": "n",
        "d": 90
       },
       {
        "n": "sessionGraceMinutes",
        "t": "n",
        "d": 10
       },
       {
        "n": "qualifiedLeadConversion",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/attribution/calls",
      "a": "Calls",
      "k": "paged",
      "q": [
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "channel",
        "t": "s"
       },
       {
        "n": "method",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/attribution/calls/{callId}",
      "a": "Call",
      "k": "obj",
      "h": "Attribution of one call with its touchpoint journey and the credit under every model.",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/attribution/weights",
      "a": "Weights",
      "k": "list",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/attribution/recompute",
      "a": "Recompute",
      "k": "obj",
      "b": [
       {
        "n": "from",
        "t": "dt",
        "r": 1
       },
       {
        "n": "to",
        "t": "dt",
        "r": 1
       },
       {
        "n": "model",
        "t": "s",
        "h": "Model to apply; null = each call's campaign model or the tenant default."
       },
       {
        "n": "campaignId",
        "t": "g"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/attribution/backfill",
      "a": "Backfill",
      "k": "obj",
      "h": "Looks again for visitor sessions of calls that have none (default: the last 24 hours).",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/attribution/reports",
      "a": "Report",
      "k": "obj",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       }
      ],
      "qp": [],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/attribution/reports/assisted",
      "a": "Assisted",
      "k": "obj",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       }
      ],
      "qp": [],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/attribution/reports/funnel",
      "a": "Funnel",
      "k": "obj",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       }
      ],
      "qp": [],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/attribution/reports/export",
      "a": "Export",
      "k": "file",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       }
      ],
      "qp": [],
      "perm": "Export"
     }
    ]
   }
  ]
 },
 {
  "key": "recordings",
  "label": "Recordings",
  "icon": "M12 14a3 3 0 003-3V6a3 3 0 00-6 0v5a3 3 0 003 3zM6 11a6 6 0 0012 0M12 17v4",
  "sections": [
   {
    "key": "Recordings",
    "label": "Recordings",
    "eps": [
     {
      "m": "GET",
      "p": "/api/recordings",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "numberId",
        "t": "g"
       },
       {
        "n": "policyId",
        "t": "g"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "isVoicemail",
        "t": "b"
       },
       {
        "n": "direction",
        "t": "s"
       },
       {
        "n": "format",
        "t": "s"
       },
       {
        "n": "channels",
        "t": "s"
       },
       {
        "n": "minDurationSeconds",
        "t": "n"
       },
       {
        "n": "maxDurationSeconds",
        "t": "n"
       },
       {
        "n": "legalHold",
        "t": "b"
       },
       {
        "n": "status",
        "t": "s",
        "o": [
         "purged",
         "all"
        ],
        "h": "ready (default) | purged | all"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/recordings/stats",
      "a": "Stats",
      "k": "obj",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/recordings/by-call/{callId}",
      "a": "ByCall",
      "k": "list",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/recordings/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/recordings/{id}/audio",
      "a": "Audio",
      "k": "file",
      "h": "Playback copy with HTTP range support (seeking in browsers).",
      "perm": "Play"
     },
     {
      "m": "GET",
      "p": "/api/recordings/{id}/stream-url",
      "a": "StreamUrl",
      "k": "obj",
      "h": "A direct, time limited URL of the playback copy (or the API URL when the storage cannot sign URLs).",
      "perm": "Play"
     },
     {
      "m": "GET",
      "p": "/api/recordings/{id}/download",
      "a": "Download",
      "k": "file",
      "h": "The original file exactly as stored (WAV with separate channels when the recording is dual channel).",
      "perm": "Download"
     },
     {
      "m": "GET",
      "p": "/api/recordings/{id}/waveform",
      "a": "Waveform",
      "k": "obj",
      "q": [
       {
        "n": "points",
        "t": "n",
        "d": 800
       }
      ],
      "perm": "Play"
     },
     {
      "m": "POST",
      "p": "/api/recordings/{id}/integrity-check",
      "a": "IntegrityCheck",
      "k": "obj",
      "q": [
       {
        "n": "verifyHash",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/recordings/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Delete"
     },
     {
      "m": "GET",
      "p": "/api/recordings/{id}/bookmarks",
      "a": "Bookmarks",
      "k": "list",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/recordings/{id}/bookmarks",
      "a": "CreateBookmark",
      "k": "obj",
      "b": [
       {
        "n": "positionMs",
        "t": "n"
       },
       {
        "n": "channel",
        "t": "s",
        "o": [
         "agent",
         "customer",
         "both"
        ],
        "h": "agent | customer | both (empty = both)"
       },
       {
        "n": "label",
        "t": "s",
        "r": 1
       },
       {
        "n": "note",
        "t": "s"
       },
       {
        "n": "color",
        "t": "s"
       }
      ],
      "perm": "Play"
     },
     {
      "m": "PUT",
      "p": "/api/recordings/{id}/bookmarks/{bookmarkId}",
      "a": "UpdateBookmark",
      "k": "obj",
      "b": [
       {
        "n": "positionMs",
        "t": "n"
       },
       {
        "n": "channel",
        "t": "s",
        "o": [
         "agent",
         "customer",
         "both"
        ],
        "h": "agent | customer | both (empty = both)"
       },
       {
        "n": "label",
        "t": "s",
        "r": 1
       },
       {
        "n": "note",
        "t": "s"
       },
       {
        "n": "color",
        "t": "s"
       }
      ],
      "perm": "Play"
     },
     {
      "m": "DELETE",
      "p": "/api/recordings/{id}/bookmarks/{bookmarkId}",
      "a": "DeleteBookmark",
      "k": "none",
      "perm": "Play"
     },
     {
      "m": "GET",
      "p": "/api/recordings/{id}/shares",
      "a": "Shares",
      "k": "list",
      "perm": "Share"
     },
     {
      "m": "POST",
      "p": "/api/recordings/{id}/shares",
      "a": "CreateShare",
      "k": "obj",
      "b": [
       {
        "n": "label",
        "t": "s"
       },
       {
        "n": "recipient",
        "t": "s"
       },
       {
        "n": "expiresInHours",
        "t": "n",
        "h": "Lifetime of the link in hours (default and maximum come from the settings)."
       },
       {
        "n": "maxUses",
        "t": "n"
       }
      ],
      "perm": "Share"
     },
     {
      "m": "DELETE",
      "p": "/api/recordings/{id}/shares/{linkId}",
      "a": "RevokeShare",
      "k": "none",
      "perm": "Share"
     },
     {
      "m": "POST",
      "p": "/api/recordings/calls/{callId}/pause",
      "a": "Pause",
      "k": "obj",
      "b": [
       {
        "n": "reason",
        "t": "s",
        "o": [
         "pci",
         "manual"
        ],
        "h": "pci | manual (default manual)"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/recordings/calls/{callId}/resume",
      "a": "Resume",
      "k": "list",
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/recordings/calls/{callId}/pauses",
      "a": "Pauses",
      "k": "list",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/recordings/access-log",
      "a": "AccessLog",
      "k": "paged",
      "q": [
       {
        "n": "recordingId",
        "t": "g"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "userId",
        "t": "s"
       },
       {
        "n": "action",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Audit"
     },
     {
      "m": "GET",
      "p": "/api/recordings/ingest-jobs",
      "a": "IngestJobs",
      "k": "paged",
      "h": "Recordings the provider saved but we could not take over (default: failed ones).",
      "q": [
       {
        "n": "status",
        "t": "s",
        "o": [
         "pending",
         "processing",
         "done",
         "failed"
        ],
        "h": "pending | processing | done | failed (default failed)"
       },
       {
        "n": "callId",
        "t": "g"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/recordings/ingest-jobs/{jobId}/retry",
      "a": "RetryIngest",
      "k": "none",
      "perm": "Manage"
     }
    ]
   },
   {
    "key": "Policies",
    "label": "Policies",
    "eps": [
     {
      "m": "GET",
      "p": "/api/recording-policies",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/recording-policies/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/recording-policies",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "mode",
        "t": "s",
        "r": 1,
        "o": [
         "automatic",
         "on_demand",
         "off"
        ],
        "h": "automatic | on_demand | off"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "numberId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "agentRole",
        "t": "s"
       },
       {
        "n": "country",
        "t": "s"
       },
       {
        "n": "channels",
        "t": "s",
        "r": 1,
        "o": [
         "dual",
         "single"
        ],
        "d": "dual",
        "h": "dual | single"
       },
       {
        "n": "format",
        "t": "s",
        "r": 1,
        "o": [
         "mp3",
         "wav"
        ],
        "h": "mp3 | wav"
       },
       {
        "n": "retentionDays",
        "t": "n"
       },
       {
        "n": "pauseOnPci",
        "t": "b"
       },
       {
        "n": "samplePercent",
        "t": "n",
        "d": 100
       }
      ],
      "perm": "Policies"
     },
     {
      "m": "PUT",
      "p": "/api/recording-policies/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "mode",
        "t": "s",
        "r": 1,
        "o": [
         "automatic",
         "on_demand",
         "off"
        ],
        "h": "automatic | on_demand | off"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "numberId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "agentRole",
        "t": "s"
       },
       {
        "n": "country",
        "t": "s"
       },
       {
        "n": "channels",
        "t": "s",
        "r": 1,
        "o": [
         "dual",
         "single"
        ],
        "d": "dual",
        "h": "dual | single"
       },
       {
        "n": "format",
        "t": "s",
        "r": 1,
        "o": [
         "mp3",
         "wav"
        ],
        "h": "mp3 | wav"
       },
       {
        "n": "retentionDays",
        "t": "n"
       },
       {
        "n": "pauseOnPci",
        "t": "b"
       },
       {
        "n": "samplePercent",
        "t": "n",
        "d": 100
       }
      ],
      "perm": "Policies"
     },
     {
      "m": "DELETE",
      "p": "/api/recording-policies/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Policies"
     },
     {
      "m": "POST",
      "p": "/api/recording-policies/test",
      "a": "Test",
      "k": "obj",
      "h": "\"What would happen to a call like this?\" Shows the matching policy and the resulting recording directive.",
      "b": [
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "numberId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "country",
        "t": "s"
       },
       {
        "n": "agentRole",
        "t": "s",
        "h": "Role of the agent (Routing may not know it; a policy with a role never matches without one)."
       },
       {
        "n": "callId",
        "t": "g",
        "h": "Makes the percentage sampling deterministic for one call."
       }
      ],
      "perm": "View"
     }
    ]
   }
  ]
 },
 {
  "key": "intelligence",
  "label": "Intelligence",
  "icon": "M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM18 16l.8 2.2L21 19l-2.2.8L18 22l-.8-2.2L15 19l2.2-.8z",
  "sections": [
   {
    "key": "Transcripts",
    "label": "Transcripts",
    "eps": [
     {
      "m": "GET",
      "p": "/api/calls/{callId}/transcript",
      "a": "Get",
      "k": "obj",
      "h": "The transcript of a call with its segments, keyword hits and analysis. Every read is audited.",
      "perm": "Transcripts"
     },
     {
      "m": "GET",
      "p": "/api/calls/{callId}/analysis",
      "a": "GetAnalysis",
      "k": "obj",
      "h": "Summary, sentiment, intent, qualification, topics and conversation metrics of a call.",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/transcripts",
      "a": "Search",
      "k": "paged",
      "h": "Search transcripts by text (optionally only one speaker) and by call, analysis and topic filters.",
      "q": [
       {
        "n": "q",
        "t": "s",
        "h": "Full text search in the (redacted) transcript."
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "speaker",
        "t": "s",
        "o": [
         "agent",
         "customer"
        ],
        "h": "With Q: only text spoken by this speaker (agent | customer)."
       },
       {
        "n": "ruleId",
        "t": "g"
       },
       {
        "n": "sentiment",
        "t": "s"
       },
       {
        "n": "language",
        "t": "s"
       },
       {
        "n": "isQualifiedLead",
        "t": "b"
       },
       {
        "n": "isVoicemail",
        "t": "b"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "topicId",
        "t": "g"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Transcripts"
     },
     {
      "m": "PUT",
      "p": "/api/transcripts/{transcriptId}/segments/{segmentId}",
      "a": "EditSegment",
      "k": "obj",
      "h": "Corrects one segment. The text before the first correction is kept; the change is audited.",
      "b": [
       {
        "n": "text",
        "t": "s",
        "r": 1
       }
      ],
      "perm": "Transcripts"
     },
     {
      "m": "POST",
      "p": "/api/calls/{callId}/transcript/reprocess",
      "a": "Reprocess",
      "k": "obj",
      "h": "Run the pipeline again for one call: full (transcribe again), analysis, or redaction (mask the stored text again).",
      "b": [
       {
        "n": "mode",
        "t": "s",
        "r": 1,
        "d": "analysis",
        "h": "full (transcribe again) | analysis (keep the transcript, analyse again) | redaction (apply the current masking rules to the stored text)"
       }
      ],
      "perm": "Reprocess"
     },
     {
      "m": "POST",
      "p": "/api/transcripts/reprocess",
      "a": "BulkReprocess",
      "k": "obj",
      "b": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "mode",
        "t": "s",
        "r": 1,
        "d": "analysis"
       },
       {
        "n": "onlyFailed",
        "t": "b"
       }
      ],
      "perm": "Reprocess"
     }
    ]
   },
   {
    "key": "Insights",
    "label": "Analysis jobs",
    "eps": [
     {
      "m": "GET",
      "p": "/api/sentiment/trend",
      "a": "SentimentTrend",
      "k": "list",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "groupBy",
        "t": "s",
        "o": [
         "day",
         "week",
         "month"
        ],
        "d": "day",
        "h": "day | week | month"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       }
      ],
      "qp": [],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/analysis-jobs",
      "a": "Jobs",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/analysis-jobs/stats",
      "a": "JobStats",
      "k": "obj",
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/analysis-jobs/{id}",
      "a": "Job",
      "k": "obj",
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/analysis-jobs/{id}/retry",
      "a": "Retry",
      "k": "obj",
      "h": "Puts a failed or dead-lettered job back in the queue.",
      "perm": "Reprocess"
     }
    ]
   },
   {
    "key": "Topics",
    "label": "Topics",
    "eps": [
     {
      "m": "GET",
      "p": "/api/topics",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "isActive",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Topics"
     },
     {
      "m": "GET",
      "p": "/api/topics/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "Topics"
     },
     {
      "m": "PUT",
      "p": "/api/topics/{id}",
      "a": "Update",
      "k": "obj",
      "h": "Rename, describe, or switch a topic off (a switched off topic is no longer attached to new calls).",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Topics"
     },
     {
      "m": "POST",
      "p": "/api/topics/{id}/merge",
      "a": "Merge",
      "k": "obj",
      "h": "Folds this topic into another one; its calls move to the target.",
      "b": [
       {
        "n": "targetId",
        "t": "g",
        "r": 1
       }
      ],
      "perm": "Topics"
     },
     {
      "m": "GET",
      "p": "/api/topics/{id}/trend",
      "a": "Trend",
      "k": "list",
      "h": "Calls per day for a topic over the last  days.",
      "q": [
       {
        "n": "days",
        "t": "n",
        "d": 30
       }
      ],
      "perm": "Topics"
     },
     {
      "m": "GET",
      "p": "/api/topics/emerging",
      "a": "Emerging",
      "k": "list",
      "h": "Topics whose volume in the last hours is far above their normal daily level.",
      "q": [
       {
        "n": "hours",
        "t": "n",
        "d": 24
       }
      ],
      "perm": "Topics"
     }
    ]
   },
   {
    "key": "KeywordRules",
    "label": "Keyword rules",
    "eps": [
     {
      "m": "GET",
      "p": "/api/keyword-rules",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "eventType",
        "t": "s"
       },
       {
        "n": "action",
        "t": "s"
       },
       {
        "n": "connectionId",
        "t": "g"
       },
       {
        "n": "active",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/keyword-rules/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/keyword-rules",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "eventType",
        "t": "s",
        "r": 1
       },
       {
        "n": "action",
        "t": "s",
        "r": 1
       },
       {
        "n": "connectionId",
        "t": "g"
       },
       {
        "n": "filters",
        "t": "j",
        "h": "[{ \"field\": \"durationSeconds\", \"op\": \"gte\", \"value\": 30 }] evaluated against the event payload."
       },
       {
        "n": "config",
        "t": "j"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "delaySeconds",
        "t": "n"
       }
      ],
      "perm": "Rules"
     },
     {
      "m": "PUT",
      "p": "/api/keyword-rules/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "eventType",
        "t": "s",
        "r": 1
       },
       {
        "n": "action",
        "t": "s",
        "r": 1
       },
       {
        "n": "connectionId",
        "t": "g"
       },
       {
        "n": "filters",
        "t": "j",
        "h": "[{ \"field\": \"durationSeconds\", \"op\": \"gte\", \"value\": 30 }] evaluated against the event payload."
       },
       {
        "n": "config",
        "t": "j"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "delaySeconds",
        "t": "n"
       }
      ],
      "perm": "Rules"
     },
     {
      "m": "DELETE",
      "p": "/api/keyword-rules/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Rules"
     },
     {
      "m": "POST",
      "p": "/api/keyword-rules/test",
      "a": "Test",
      "k": "obj",
      "h": "Try a rule (saved, or typed in) on sample text before saving it.",
      "b": [
       {
        "n": "ruleId",
        "t": "g",
        "h": "Test a saved rule, or send the definition below."
       },
       {
        "n": "phrases",
        "t": "sa"
       },
       {
        "n": "useRegex",
        "t": "b"
       },
       {
        "n": "wholeWord",
        "t": "b",
        "d": true
       },
       {
        "n": "caseSensitive",
        "t": "b"
       },
       {
        "n": "speakerScope",
        "t": "s",
        "d": "any"
       },
       {
        "n": "text",
        "t": "s",
        "r": 1
       },
       {
        "n": "speaker",
        "t": "s",
        "d": "unknown"
       }
      ],
      "perm": "Rules"
     },
     {
      "m": "POST",
      "p": "/api/keyword-rules/{id}/backfill",
      "a": "Backfill",
      "k": "obj",
      "h": "Apply a rule to transcripts that already exist (up to 5,000 per request, oldest first).",
      "b": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "perm": "Rules"
     },
     {
      "m": "GET",
      "p": "/api/keyword-hits",
      "a": "Hits",
      "k": "paged",
      "q": [
       {
        "n": "ruleId",
        "t": "g"
       },
       {
        "n": "severity",
        "t": "s"
       },
       {
        "n": "category",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "speaker",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     }
    ]
   },
   {
    "key": "AnalysisProfiles",
    "label": "Profiles",
    "eps": [
     {
      "m": "GET",
      "p": "/api/analysis-profiles",
      "a": "List",
      "k": "list",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/analysis-profiles/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/analysis-profiles",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "isDefault",
        "t": "b"
       },
       {
        "n": "outputLanguage",
        "t": "s",
        "r": 1,
        "d": "en"
       },
       {
        "n": "transcriptionLanguage",
        "t": "s"
       },
       {
        "n": "redactPii",
        "t": "b"
       },
       {
        "n": "transcribeVoicemail",
        "t": "b",
        "d": true
       },
       {
        "n": "minCallSeconds",
        "t": "n",
        "d": 3
       },
       {
        "n": "silenceGapSeconds",
        "t": "n",
        "d": 3
       },
       {
        "n": "enableSummary",
        "t": "b",
        "d": true
       },
       {
        "n": "enableSentiment",
        "t": "b",
        "d": true
       },
       {
        "n": "enableIntent",
        "t": "b",
        "d": true
       },
       {
        "n": "enableQualification",
        "t": "b",
        "d": true
       },
       {
        "n": "enableTopics",
        "t": "b",
        "d": true
       },
       {
        "n": "enableCompliance",
        "t": "b",
        "d": true
       },
       {
        "n": "enableNextBestAction",
        "t": "b",
        "d": true
       },
       {
        "n": "enableObjections",
        "t": "b",
        "d": true
       },
       {
        "n": "segmentSentiment",
        "t": "b"
       },
       {
        "n": "promptAdditions",
        "t": "s"
       },
       {
        "n": "complianceChecks",
        "t": "sa"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "PUT",
      "p": "/api/analysis-profiles/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "isDefault",
        "t": "b"
       },
       {
        "n": "outputLanguage",
        "t": "s",
        "r": 1,
        "d": "en"
       },
       {
        "n": "transcriptionLanguage",
        "t": "s"
       },
       {
        "n": "redactPii",
        "t": "b"
       },
       {
        "n": "transcribeVoicemail",
        "t": "b",
        "d": true
       },
       {
        "n": "minCallSeconds",
        "t": "n",
        "d": 3
       },
       {
        "n": "silenceGapSeconds",
        "t": "n",
        "d": 3
       },
       {
        "n": "enableSummary",
        "t": "b",
        "d": true
       },
       {
        "n": "enableSentiment",
        "t": "b",
        "d": true
       },
       {
        "n": "enableIntent",
        "t": "b",
        "d": true
       },
       {
        "n": "enableQualification",
        "t": "b",
        "d": true
       },
       {
        "n": "enableTopics",
        "t": "b",
        "d": true
       },
       {
        "n": "enableCompliance",
        "t": "b",
        "d": true
       },
       {
        "n": "enableNextBestAction",
        "t": "b",
        "d": true
       },
       {
        "n": "enableObjections",
        "t": "b",
        "d": true
       },
       {
        "n": "segmentSentiment",
        "t": "b"
       },
       {
        "n": "promptAdditions",
        "t": "s"
       },
       {
        "n": "complianceChecks",
        "t": "sa"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/analysis-profiles/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Manage"
     }
    ]
   }
  ]
 },
 {
  "key": "quality",
  "label": "Quality",
  "icon": "M12 3l2.4 1.8 3-.2.9 2.9 2.4 1.8-.9 2.9.9 2.9-2.4 1.8-.9 2.9-3-.2L12 21l-2.4-1.8-3 .2-.9-2.9-2.4-1.8.9-2.9-.9-2.9 2.4-1.8.9-2.9 3 .2zM8.5 12l2.5 2.5 4.5-5",
  "sections": [
   {
    "key": "Evaluations",
    "label": "Evaluations",
    "eps": [
     {
      "m": "GET",
      "p": "/api/quality/evaluations",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "type",
        "t": "s"
       },
       {
        "n": "evaluatorId",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "passed",
        "t": "b"
       },
       {
        "n": "criticalFail",
        "t": "b"
       },
       {
        "n": "needsReview",
        "t": "b"
       },
       {
        "n": "mine",
        "t": "b",
        "h": "Only the work assigned to the signed-in evaluator."
       },
       {
        "n": "unassigned",
        "t": "b",
        "h": "Only pending evaluations nobody has been given yet."
       },
       {
        "n": "overdue",
        "t": "b"
       },
       {
        "n": "open",
        "t": "b",
        "h": "Only evaluations that are not submitted yet (pending or draft)."
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/quality/evaluations/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/quality/evaluations/{id}/logs",
      "a": "Logs",
      "k": "list",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/quality/evaluations/queue/stats",
      "a": "QueueStats",
      "k": "obj",
      "h": "Numbers for the evaluator's queue screen.",
      "perm": "Evaluate"
     },
     {
      "m": "GET",
      "p": "/api/quality/evaluations/queue/mine",
      "a": "Mine",
      "k": "paged",
      "h": "The evaluations assigned to the signed-in evaluator that are not finished.",
      "q": [
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "type",
        "t": "s"
       },
       {
        "n": "evaluatorId",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "passed",
        "t": "b"
       },
       {
        "n": "criticalFail",
        "t": "b"
       },
       {
        "n": "needsReview",
        "t": "b"
       },
       {
        "n": "mine",
        "t": "b",
        "h": "Only the work assigned to the signed-in evaluator."
       },
       {
        "n": "unassigned",
        "t": "b",
        "h": "Only pending evaluations nobody has been given yet."
       },
       {
        "n": "overdue",
        "t": "b"
       },
       {
        "n": "open",
        "t": "b",
        "h": "Only evaluations that are not submitted yet (pending or draft)."
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Evaluate"
     },
     {
      "m": "GET",
      "p": "/api/quality/evaluations/queue/available",
      "a": "Available",
      "k": "paged",
      "h": "Sampled calls that nobody has taken yet.",
      "q": [
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "type",
        "t": "s"
       },
       {
        "n": "evaluatorId",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "passed",
        "t": "b"
       },
       {
        "n": "criticalFail",
        "t": "b"
       },
       {
        "n": "needsReview",
        "t": "b"
       },
       {
        "n": "mine",
        "t": "b",
        "h": "Only the work assigned to the signed-in evaluator."
       },
       {
        "n": "unassigned",
        "t": "b",
        "h": "Only pending evaluations nobody has been given yet."
       },
       {
        "n": "overdue",
        "t": "b"
       },
       {
        "n": "open",
        "t": "b",
        "h": "Only evaluations that are not submitted yet (pending or draft)."
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Evaluate"
     },
     {
      "m": "POST",
      "p": "/api/quality/evaluations/queue/claim-next",
      "a": "ClaimNext",
      "k": "obj",
      "h": "Takes the next evaluation: first work assigned to the caller, then the oldest open one. 204 when the queue is empty.",
      "b": [
       {
        "n": "formId",
        "t": "g",
        "h": "Only claim work for this form."
       }
      ],
      "perm": "Evaluate"
     },
     {
      "m": "POST",
      "p": "/api/quality/evaluations",
      "a": "Create",
      "k": "obj",
      "h": "Starts evaluating a call of the evaluator's choice.",
      "b": [
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g",
        "h": "Used when the Calls service cannot tell who handled the call."
       },
       {
        "n": "queueId",
        "t": "g"
       }
      ],
      "perm": "Evaluate"
     },
     {
      "m": "POST",
      "p": "/api/quality/evaluations/{id}/claim",
      "a": "Claim",
      "k": "obj",
      "perm": "Evaluate"
     },
     {
      "m": "PUT",
      "p": "/api/quality/evaluations/{id}",
      "a": "Save",
      "k": "obj",
      "h": "Saves answers without submitting (autosave).",
      "b": [
       {
        "n": "answers",
        "t": "j"
       },
       {
        "n": "comment",
        "t": "s"
       }
      ],
      "perm": "Evaluate"
     },
     {
      "m": "POST",
      "p": "/api/quality/evaluations/{id}/submit",
      "a": "Submit",
      "k": "obj",
      "b": [
       {
        "n": "answers",
        "t": "j"
       },
       {
        "n": "comment",
        "t": "s"
       }
      ],
      "perm": "Evaluate"
     },
     {
      "m": "POST",
      "p": "/api/quality/evaluations/{id}/assign",
      "a": "Assign",
      "k": "obj",
      "b": [
       {
        "n": "evaluatorId",
        "t": "s",
        "r": 1
       },
       {
        "n": "evaluatorName",
        "t": "s"
       },
       {
        "n": "dueAt",
        "t": "dt"
       }
      ],
      "perm": "Review"
     },
     {
      "m": "POST",
      "p": "/api/quality/evaluations/{id}/review",
      "a": "Review",
      "k": "obj",
      "h": "Confirms (and may correct) a submitted evaluation, in particular an AI score that waits for a person.",
      "b": [
       {
        "n": "answers",
        "t": "j",
        "h": "Answers the reviewer changes. Changed answers become manual answers."
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "Review"
     },
     {
      "m": "POST",
      "p": "/api/quality/evaluations/{id}/reopen",
      "a": "Reopen",
      "k": "obj",
      "b": [
       {
        "n": "note",
        "t": "s"
       }
      ],
      "perm": "Review"
     },
     {
      "m": "POST",
      "p": "/api/quality/evaluations/{id}/finalize",
      "a": "Finalize",
      "k": "obj",
      "perm": "Review"
     },
     {
      "m": "POST",
      "p": "/api/quality/evaluations/{id}/resolve-dispute",
      "a": "ResolveDispute",
      "k": "obj",
      "b": [
       {
        "n": "resolution",
        "t": "s",
        "r": 1
       },
       {
        "n": "answers",
        "t": "j"
       }
      ],
      "perm": "Review"
     },
     {
      "m": "DELETE",
      "p": "/api/quality/evaluations/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Manage"
     }
    ]
   },
   {
    "key": "Forms",
    "label": "Scorecards",
    "eps": [
     {
      "m": "GET",
      "p": "/api/quality/forms",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "isActive",
        "t": "b"
       },
       {
        "n": "category",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/quality/forms/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/quality/forms",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "category",
        "t": "s",
        "d": "general"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "autoCoachBelowPercent",
        "t": "n"
       }
      ],
      "perm": "Forms"
     },
     {
      "m": "PUT",
      "p": "/api/quality/forms/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "category",
        "t": "s",
        "d": "general"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "autoCoachBelowPercent",
        "t": "n"
       }
      ],
      "perm": "Forms"
     },
     {
      "m": "DELETE",
      "p": "/api/quality/forms/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Forms"
     },
     {
      "m": "POST",
      "p": "/api/quality/forms/{id}/clone",
      "a": "Clone",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       }
      ],
      "perm": "Forms"
     },
     {
      "m": "GET",
      "p": "/api/quality/forms/{id}/versions",
      "a": "Versions",
      "k": "list",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/quality/forms/{id}/versions/current",
      "a": "Current",
      "k": "obj",
      "h": "The published version that new evaluations use.",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/quality/forms/{id}/versions/{versionId}",
      "a": "Version",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/quality/forms/{id}/versions",
      "a": "CreateVersion",
      "k": "obj",
      "h": "Starts a new draft as a copy of the current version (or of the version named in the body).",
      "b": [
       {
        "n": "copyFromVersionId",
        "t": "g",
        "h": "Start the draft as a copy of this version. Without it the draft copies the current published version, or is empty."
       }
      ],
      "perm": "Forms"
     },
     {
      "m": "PUT",
      "p": "/api/quality/forms/{id}/versions/{versionId}",
      "a": "SaveDraft",
      "k": "obj",
      "h": "Replaces the sections and questions of a draft version.",
      "b": [
       {
        "n": "passThreshold",
        "t": "n",
        "d": 80
       },
       {
        "n": "notes",
        "t": "s"
       },
       {
        "n": "sections",
        "t": "j",
        "r": 1
       }
      ],
      "perm": "Forms"
     },
     {
      "m": "DELETE",
      "p": "/api/quality/forms/{id}/versions/{versionId}",
      "a": "DeleteDraft",
      "k": "none",
      "perm": "Forms"
     },
     {
      "m": "POST",
      "p": "/api/quality/forms/{id}/versions/{versionId}/publish",
      "a": "Publish",
      "k": "obj",
      "perm": "Forms"
     }
    ]
   },
   {
    "key": "Calibrations",
    "label": "Calibrations",
    "eps": [
     {
      "m": "GET",
      "p": "/api/quality/calibrations",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "formId",
        "t": "g"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Calibrate"
     },
     {
      "m": "GET",
      "p": "/api/quality/calibrations/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "Calibrate"
     },
     {
      "m": "GET",
      "p": "/api/quality/calibrations/{id}/comparison",
      "a": "Comparison",
      "k": "obj",
      "h": "Every evaluator's answer to every question of a closed session.",
      "perm": "Calibrate"
     },
     {
      "m": "POST",
      "p": "/api/quality/calibrations",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "masterEvaluatorId",
        "t": "s",
        "r": 1,
        "h": "The reference evaluator whose answers the others are compared with. Added to the participants when missing."
       },
       {
        "n": "participants",
        "t": "j",
        "r": 1
       },
       {
        "n": "dueAt",
        "t": "dt"
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "Calibrate"
     },
     {
      "m": "POST",
      "p": "/api/quality/calibrations/{id}/close",
      "a": "Close",
      "k": "obj",
      "h": "Closes the session and computes deviation, agreement and kappa from the submitted evaluations.",
      "perm": "Calibrate"
     },
     {
      "m": "DELETE",
      "p": "/api/quality/calibrations/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Calibrate"
     },
     {
      "m": "GET",
      "p": "/api/quality/calibrations/reliability",
      "a": "Reliability",
      "k": "obj",
      "h": "How consistent the evaluators are over a period (default: the last 180 days).",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "perm": "Reports"
     }
    ]
   },
   {
    "key": "Coaching",
    "label": "Coaching",
    "eps": [
     {
      "m": "GET",
      "p": "/api/quality/coaching/items",
      "a": "ListItems",
      "k": "paged",
      "q": [
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "planId",
        "t": "g"
       },
       {
        "n": "evaluationId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "priority",
        "t": "s"
       },
       {
        "n": "source",
        "t": "s"
       },
       {
        "n": "overdue",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Coach"
     },
     {
      "m": "GET",
      "p": "/api/quality/coaching/items/{id}",
      "a": "GetItem",
      "k": "obj",
      "perm": "Coach"
     },
     {
      "m": "POST",
      "p": "/api/quality/coaching/items",
      "a": "CreateItem",
      "k": "obj",
      "b": [
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "planId",
        "t": "g"
       },
       {
        "n": "evaluationId",
        "t": "g"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "title",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "category",
        "t": "s"
       },
       {
        "n": "priority",
        "t": "s",
        "d": "normal"
       },
       {
        "n": "dueAt",
        "t": "dt"
       }
      ],
      "perm": "Coach"
     },
     {
      "m": "PUT",
      "p": "/api/quality/coaching/items/{id}",
      "a": "UpdateItem",
      "k": "obj",
      "b": [
       {
        "n": "title",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "category",
        "t": "s"
       },
       {
        "n": "priority",
        "t": "s",
        "d": "normal"
       },
       {
        "n": "dueAt",
        "t": "dt"
       },
       {
        "n": "planId",
        "t": "g"
       }
      ],
      "perm": "Coach"
     },
     {
      "m": "POST",
      "p": "/api/quality/coaching/items/{id}/status",
      "a": "SetItemStatus",
      "k": "obj",
      "b": [
       {
        "n": "status",
        "t": "s",
        "r": 1
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "Coach"
     },
     {
      "m": "DELETE",
      "p": "/api/quality/coaching/items/{id}",
      "a": "DeleteItem",
      "k": "none",
      "perm": "Coach"
     },
     {
      "m": "GET",
      "p": "/api/quality/coaching/plans",
      "a": "ListPlans",
      "k": "paged",
      "q": [
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Coach"
     },
     {
      "m": "GET",
      "p": "/api/quality/coaching/plans/{id}",
      "a": "GetPlan",
      "k": "obj",
      "perm": "Coach"
     },
     {
      "m": "POST",
      "p": "/api/quality/coaching/plans",
      "a": "CreatePlan",
      "k": "obj",
      "b": [
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "title",
        "t": "s",
        "r": 1
       },
       {
        "n": "goal",
        "t": "s"
       },
       {
        "n": "startsOn",
        "t": "dt"
       },
       {
        "n": "endsOn",
        "t": "dt"
       },
       {
        "n": "targetPercent",
        "t": "n"
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "Coach"
     },
     {
      "m": "PUT",
      "p": "/api/quality/coaching/plans/{id}",
      "a": "UpdatePlan",
      "k": "obj",
      "b": [
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "title",
        "t": "s",
        "r": 1
       },
       {
        "n": "goal",
        "t": "s"
       },
       {
        "n": "startsOn",
        "t": "dt"
       },
       {
        "n": "endsOn",
        "t": "dt"
       },
       {
        "n": "targetPercent",
        "t": "n"
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "Coach"
     },
     {
      "m": "POST",
      "p": "/api/quality/coaching/plans/{id}/status",
      "a": "SetPlanStatus",
      "k": "obj",
      "b": [
       {
        "n": "status",
        "t": "s",
        "r": 1
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "Coach"
     },
     {
      "m": "DELETE",
      "p": "/api/quality/coaching/plans/{id}",
      "a": "DeletePlan",
      "k": "none",
      "perm": "Coach"
     }
    ]
   },
   {
    "key": "Alerts",
    "label": "Alerts",
    "eps": [
     {
      "m": "GET",
      "p": "/api/quality/alerts",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "type",
        "t": "s"
       },
       {
        "n": "severity",
        "t": "s"
       },
       {
        "n": "agentId",
        "t": "g"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/quality/alerts/summary",
      "a": "Summary",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/quality/alerts/{id}/acknowledge",
      "a": "Acknowledge",
      "k": "obj",
      "perm": "Review"
     },
     {
      "m": "POST",
      "p": "/api/quality/alerts/{id}/resolve",
      "a": "Resolve",
      "k": "obj",
      "perm": "Review"
     }
    ]
   },
   {
    "key": "Automation",
    "label": "Automation",
    "eps": [
     {
      "m": "GET",
      "p": "/api/quality/ai-rules",
      "a": "ListRules",
      "k": "paged",
      "q": [
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "isActive",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/quality/ai-rules/{id}",
      "a": "GetRule",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/quality/ai-rules",
      "a": "CreateRule",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "trigger",
        "t": "s",
        "r": 1,
        "d": "analysis_ready"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "direction",
        "t": "s"
       },
       {
        "n": "minDurationSeconds",
        "t": "n",
        "d": 30
       },
       {
        "n": "maxDurationSeconds",
        "t": "n"
       },
       {
        "n": "samplePercent",
        "t": "n",
        "d": 100
       },
       {
        "n": "dailyLimit",
        "t": "n"
       },
       {
        "n": "requireReview",
        "t": "b"
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "PUT",
      "p": "/api/quality/ai-rules/{id}",
      "a": "UpdateRule",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "trigger",
        "t": "s",
        "r": 1,
        "d": "analysis_ready"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "direction",
        "t": "s"
       },
       {
        "n": "minDurationSeconds",
        "t": "n",
        "d": 30
       },
       {
        "n": "maxDurationSeconds",
        "t": "n"
       },
       {
        "n": "samplePercent",
        "t": "n",
        "d": 100
       },
       {
        "n": "dailyLimit",
        "t": "n"
       },
       {
        "n": "requireReview",
        "t": "b"
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/quality/ai-rules/{id}",
      "a": "DeleteRule",
      "k": "none",
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/quality/ai-rules/score-call",
      "a": "ScoreCall",
      "k": "obj",
      "h": "Asks for an AI score of one call now. The work runs in the background; the result is an evaluation.",
      "b": [
       {
        "n": "callId",
        "t": "g"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/quality/sampling-plans",
      "a": "ListPlans",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/quality/sampling-plans/{id}",
      "a": "GetPlan",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/quality/sampling-plans",
      "a": "CreatePlan",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "direction",
        "t": "s"
       },
       {
        "n": "minDurationSeconds",
        "t": "n",
        "d": 60
       },
       {
        "n": "maxDurationSeconds",
        "t": "n"
       },
       {
        "n": "samplePercent",
        "t": "n",
        "d": 5
       },
       {
        "n": "perAgentPerWeek",
        "t": "n"
       },
       {
        "n": "assignmentMode",
        "t": "s",
        "r": 1,
        "d": "pool"
       },
       {
        "n": "evaluatorIds",
        "t": "sa"
       },
       {
        "n": "dueDays",
        "t": "n",
        "d": 7
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "PUT",
      "p": "/api/quality/sampling-plans/{id}",
      "a": "UpdatePlan",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "direction",
        "t": "s"
       },
       {
        "n": "minDurationSeconds",
        "t": "n",
        "d": 60
       },
       {
        "n": "maxDurationSeconds",
        "t": "n"
       },
       {
        "n": "samplePercent",
        "t": "n",
        "d": 5
       },
       {
        "n": "perAgentPerWeek",
        "t": "n"
       },
       {
        "n": "assignmentMode",
        "t": "s",
        "r": 1,
        "d": "pool"
       },
       {
        "n": "evaluatorIds",
        "t": "sa"
       },
       {
        "n": "dueDays",
        "t": "n",
        "d": 7
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/quality/sampling-plans/{id}",
      "a": "DeletePlan",
      "k": "none",
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/quality/sampling-plans/{id}/run",
      "a": "RunPlan",
      "k": "obj",
      "h": "Applies a plan to the calls of a past period now.",
      "b": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "limit",
        "t": "n",
        "d": 100,
        "h": "How many calls of the period are looked at."
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/quality/jobs",
      "a": "ListJobs",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "kind",
        "t": "s"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "deadLetter",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/quality/jobs/stats",
      "a": "JobStats",
      "k": "obj",
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/quality/jobs/{id}/retry",
      "a": "RetryJob",
      "k": "obj",
      "perm": "Manage"
     }
    ]
   },
   {
    "key": "Reports",
    "label": "Reports",
    "eps": [
     {
      "m": "GET",
      "p": "/api/quality/reports/overview",
      "a": "Overview",
      "k": "obj",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       }
      ],
      "qp": [],
      "perm": "Reports"
     },
     {
      "m": "GET",
      "p": "/api/quality/reports/scorecard/{agentId}",
      "a": "Scorecard",
      "k": "obj",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       }
      ],
      "qp": [],
      "perm": "Reports"
     },
     {
      "m": "GET",
      "p": "/api/quality/reports/leaderboard",
      "a": "Leaderboard",
      "k": "list",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       },
       {
        "n": "minEvaluations",
        "t": "n",
        "h": "Agents with fewer evaluations are left out. Defaults to the setting LeaderboardMinEvaluations."
       },
       {
        "n": "top",
        "t": "n",
        "d": 50
       },
       {
        "n": "ascending",
        "t": "b",
        "h": "Lowest scores first."
       }
      ],
      "qp": [],
      "perm": "Reports"
     },
     {
      "m": "GET",
      "p": "/api/quality/reports/trend",
      "a": "Trend",
      "k": "list",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       },
       {
        "n": "bucket",
        "t": "s",
        "d": "day",
        "h": "day, week or month."
       }
      ],
      "qp": [],
      "perm": "Reports"
     },
     {
      "m": "GET",
      "p": "/api/quality/reports/failing-questions",
      "a": "FailingQuestions",
      "k": "list",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       },
       {
        "n": "top",
        "t": "n",
        "d": 25
       },
       {
        "n": "minAnswers",
        "t": "n",
        "d": 5,
        "h": "Questions answered fewer times than this are left out."
       }
      ],
      "qp": [],
      "perm": "Reports"
     },
     {
      "m": "GET",
      "p": "/api/quality/reports/heatmap",
      "a": "Heatmap",
      "k": "obj",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       },
       {
        "n": "questions",
        "t": "n",
        "d": 15
       },
       {
        "n": "agents",
        "t": "n",
        "d": 30
       }
      ],
      "qp": [],
      "perm": "Reports"
     },
     {
      "m": "GET",
      "p": "/api/quality/reports/evaluators",
      "a": "Evaluators",
      "k": "list",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       }
      ],
      "qp": [],
      "perm": "Reports"
     },
     {
      "m": "GET",
      "p": "/api/quality/reports/export.csv",
      "a": "Export",
      "k": "file",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       }
      ],
      "qp": [],
      "perm": "Reports"
     }
    ]
   },
   {
    "key": "Self",
    "label": "My scores",
    "eps": [
     {
      "m": "GET",
      "p": "/api/quality/me/evaluations",
      "a": "Evaluations",
      "k": "paged",
      "q": [
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "callId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "type",
        "t": "s"
       },
       {
        "n": "evaluatorId",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "passed",
        "t": "b"
       },
       {
        "n": "criticalFail",
        "t": "b"
       },
       {
        "n": "needsReview",
        "t": "b"
       },
       {
        "n": "mine",
        "t": "b",
        "h": "Only the work assigned to the signed-in evaluator."
       },
       {
        "n": "unassigned",
        "t": "b",
        "h": "Only pending evaluations nobody has been given yet."
       },
       {
        "n": "overdue",
        "t": "b"
       },
       {
        "n": "open",
        "t": "b",
        "h": "Only evaluations that are not submitted yet (pending or draft)."
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Self"
     },
     {
      "m": "GET",
      "p": "/api/quality/me/evaluations/{id}",
      "a": "Evaluation",
      "k": "obj",
      "perm": "Self"
     },
     {
      "m": "POST",
      "p": "/api/quality/me/evaluations/{id}/acknowledge",
      "a": "Acknowledge",
      "k": "obj",
      "b": [
       {
        "n": "agentComment",
        "t": "s"
       }
      ],
      "perm": "Self"
     },
     {
      "m": "POST",
      "p": "/api/quality/me/evaluations/{id}/dispute",
      "a": "Dispute",
      "k": "obj",
      "b": [
       {
        "n": "reason",
        "t": "s",
        "r": 1
       }
      ],
      "perm": "Self"
     },
     {
      "m": "GET",
      "p": "/api/quality/me/scorecard",
      "a": "Scorecard",
      "k": "obj",
      "q": [
       {
        "n": "from",
        "t": "dt",
        "h": "Start of the period (inclusive). Defaults to 30 days before the end."
       },
       {
        "n": "to",
        "t": "dt",
        "h": "End of the period (exclusive). Defaults to now."
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "formId",
        "t": "g"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "type",
        "t": "s",
        "h": "manual or ai. Empty means both."
       }
      ],
      "qp": [],
      "perm": "Self"
     },
     {
      "m": "GET",
      "p": "/api/quality/me/coaching/items",
      "a": "CoachingItems",
      "k": "paged",
      "q": [
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "planId",
        "t": "g"
       },
       {
        "n": "evaluationId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "priority",
        "t": "s"
       },
       {
        "n": "source",
        "t": "s"
       },
       {
        "n": "overdue",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Self"
     },
     {
      "m": "GET",
      "p": "/api/quality/me/coaching/items/{id}",
      "a": "CoachingItem",
      "k": "obj",
      "perm": "Self"
     },
     {
      "m": "POST",
      "p": "/api/quality/me/coaching/items/{id}/acknowledge",
      "a": "AcknowledgeCoaching",
      "k": "obj",
      "perm": "Self"
     },
     {
      "m": "POST",
      "p": "/api/quality/me/coaching/items/{id}/status",
      "a": "UpdateCoaching",
      "k": "obj",
      "b": [
       {
        "n": "status",
        "t": "s",
        "r": 1
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "Self"
     },
     {
      "m": "GET",
      "p": "/api/quality/me/coaching/plans",
      "a": "CoachingPlans",
      "k": "list",
      "perm": "Self"
     }
    ]
   }
  ]
 },
 {
  "key": "analytics",
  "label": "Analytics",
  "icon": "M4 20V10M10 20V4M16 20v-7M22 20H2",
  "sections": [
   {
    "key": "Reports",
    "label": "Reports",
    "eps": [
     {
      "m": "GET",
      "p": "/api/analytics/reports",
      "a": "Kinds",
      "k": "list",
      "h": "The ready-made report kinds.",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/analytics/reports/{kind}",
      "a": "Run",
      "k": "none",
      "h": "Runs a ready-made report. Query: range=last_30_days | from= &amp; to=, timezone=, metrics=a,b (replaces the default metrics), dimensions=a,b (extra grouping), sortBy=, desc=, limit=, compare=true, for",
      "q": [
       {
        "n": "range",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "timezone",
        "t": "s"
       },
       {
        "n": "metrics",
        "t": "s"
       },
       {
        "n": "dimensions",
        "t": "s"
       },
       {
        "n": "sortBy",
        "t": "s"
       },
       {
        "n": "desc",
        "t": "b"
       },
       {
        "n": "limit",
        "t": "n"
       },
       {
        "n": "compare",
        "t": "b"
       },
       {
        "n": "format",
        "t": "s"
       }
      ],
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/analytics/reports/query",
      "a": "Query",
      "k": "obj",
      "h": "Ad-hoc query from the report builder.",
      "b": [
       {
        "n": "dimensions",
        "t": "sa"
       },
       {
        "n": "metrics",
        "t": "sa"
       },
       {
        "n": "filters",
        "t": "j"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "timezone",
        "t": "s"
       },
       {
        "n": "sortBy",
        "t": "s"
       },
       {
        "n": "sortDesc",
        "t": "b",
        "d": true
       },
       {
        "n": "limit",
        "t": "n",
        "d": 1000
       },
       {
        "n": "comparePrevious",
        "t": "b"
       }
      ],
      "perm": "Builder"
     },
     {
      "m": "GET",
      "p": "/api/analytics/reports/funnel",
      "a": "Funnel",
      "k": "obj",
      "q": [
       {
        "n": "range",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "timezone",
        "t": "s"
       }
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/analytics/reports/trends",
      "a": "Trends",
      "k": "obj",
      "h": "Series of one metric (granularity hour|day|week|month) with moving average, hour-of-week pattern and week over week change.",
      "q": [
       {
        "n": "metric",
        "t": "s"
       },
       {
        "n": "granularity",
        "t": "s"
       },
       {
        "n": "range",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "timezone",
        "t": "s"
       },
       {
        "n": "window",
        "t": "n"
       }
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/analytics/reports/anomalies",
      "a": "Anomalies",
      "k": "paged",
      "q": [
       {
        "n": "acknowledged",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/analytics/reports/anomalies/{id}/acknowledge",
      "a": "Acknowledge",
      "k": "obj",
      "perm": "Manage"
     }
    ]
   },
   {
    "key": "Definitions",
    "label": "Saved reports",
    "eps": [
     {
      "m": "GET",
      "p": "/api/analytics/reports/definitions",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Reports"
     },
     {
      "m": "GET",
      "p": "/api/analytics/reports/definitions/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "Reports"
     },
     {
      "m": "POST",
      "p": "/api/analytics/reports/definitions",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "dimensions",
        "t": "sa"
       },
       {
        "n": "metrics",
        "t": "sa"
       },
       {
        "n": "filters",
        "t": "j"
       },
       {
        "n": "dateRangeType",
        "t": "s",
        "d": "relative"
       },
       {
        "n": "relativeRange",
        "t": "s",
        "d": "last_7_days"
       },
       {
        "n": "fromUtc",
        "t": "dt"
       },
       {
        "n": "toUtc",
        "t": "dt"
       },
       {
        "n": "sortBy",
        "t": "s"
       },
       {
        "n": "sortDesc",
        "t": "b",
        "d": true
       },
       {
        "n": "rowLimit",
        "t": "n",
        "d": 1000
       },
       {
        "n": "chartHint",
        "t": "s"
       },
       {
        "n": "timezone",
        "t": "s",
        "d": "UTC"
       },
       {
        "n": "comparePrevious",
        "t": "b"
       },
       {
        "n": "visibility",
        "t": "s",
        "d": "private"
       }
      ],
      "perm": "Builder"
     },
     {
      "m": "PUT",
      "p": "/api/analytics/reports/definitions/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "dimensions",
        "t": "sa"
       },
       {
        "n": "metrics",
        "t": "sa"
       },
       {
        "n": "filters",
        "t": "j"
       },
       {
        "n": "dateRangeType",
        "t": "s",
        "d": "relative"
       },
       {
        "n": "relativeRange",
        "t": "s",
        "d": "last_7_days"
       },
       {
        "n": "fromUtc",
        "t": "dt"
       },
       {
        "n": "toUtc",
        "t": "dt"
       },
       {
        "n": "sortBy",
        "t": "s"
       },
       {
        "n": "sortDesc",
        "t": "b",
        "d": true
       },
       {
        "n": "rowLimit",
        "t": "n",
        "d": 1000
       },
       {
        "n": "chartHint",
        "t": "s"
       },
       {
        "n": "timezone",
        "t": "s",
        "d": "UTC"
       },
       {
        "n": "comparePrevious",
        "t": "b"
       },
       {
        "n": "visibility",
        "t": "s",
        "d": "private"
       }
      ],
      "perm": "Builder"
     },
     {
      "m": "DELETE",
      "p": "/api/analytics/reports/definitions/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Builder"
     },
     {
      "m": "GET",
      "p": "/api/analytics/reports/definitions/{id}/result",
      "a": "Result",
      "k": "obj",
      "h": "Runs the saved report now and returns the result in the response (no file, no delivery).",
      "perm": "Reports"
     },
     {
      "m": "POST",
      "p": "/api/analytics/reports/definitions/{id}/run",
      "a": "Run",
      "k": "obj",
      "h": "Queues a run that produces a file (csv, json or html) kept for the run retention period.",
      "b": [
       {
        "n": "format",
        "t": "s"
       }
      ],
      "perm": "Reports"
     },
     {
      "m": "GET",
      "p": "/api/analytics/reports/schedules",
      "a": "Schedules",
      "k": "paged",
      "q": [
       {
        "n": "definitionId",
        "t": "g"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Schedules"
     },
     {
      "m": "GET",
      "p": "/api/analytics/reports/schedules/{id}",
      "a": "GetSchedule",
      "k": "obj",
      "perm": "Schedules"
     },
     {
      "m": "POST",
      "p": "/api/analytics/reports/schedules",
      "a": "CreateSchedule",
      "k": "obj",
      "b": [
       {
        "n": "definitionId",
        "t": "g",
        "r": 1
       },
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "cronExpression",
        "t": "s",
        "r": 1,
        "d": "0 8 * * 1"
       },
       {
        "n": "timezone",
        "t": "s",
        "d": "UTC"
       },
       {
        "n": "format",
        "t": "s",
        "d": "csv"
       },
       {
        "n": "deliveryChannel",
        "t": "s",
        "d": "email"
       },
       {
        "n": "recipients",
        "t": "s"
       },
       {
        "n": "integrationConnectionId",
        "t": "g"
       },
       {
        "n": "includeLink",
        "t": "b",
        "d": true
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Schedules"
     },
     {
      "m": "PUT",
      "p": "/api/analytics/reports/schedules/{id}",
      "a": "UpdateSchedule",
      "k": "obj",
      "b": [
       {
        "n": "definitionId",
        "t": "g",
        "r": 1
       },
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "cronExpression",
        "t": "s",
        "r": 1,
        "d": "0 8 * * 1"
       },
       {
        "n": "timezone",
        "t": "s",
        "d": "UTC"
       },
       {
        "n": "format",
        "t": "s",
        "d": "csv"
       },
       {
        "n": "deliveryChannel",
        "t": "s",
        "d": "email"
       },
       {
        "n": "recipients",
        "t": "s"
       },
       {
        "n": "integrationConnectionId",
        "t": "g"
       },
       {
        "n": "includeLink",
        "t": "b",
        "d": true
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Schedules"
     },
     {
      "m": "DELETE",
      "p": "/api/analytics/reports/schedules/{id}",
      "a": "DeleteSchedule",
      "k": "none",
      "perm": "Schedules"
     },
     {
      "m": "POST",
      "p": "/api/analytics/reports/schedules/{id}/run",
      "a": "RunSchedule",
      "k": "obj",
      "h": "Generates and delivers the scheduled report right now.",
      "perm": "Schedules"
     },
     {
      "m": "GET",
      "p": "/api/analytics/reports/runs",
      "a": "Runs",
      "k": "paged",
      "q": [
       {
        "n": "definitionId",
        "t": "g"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Reports"
     },
     {
      "m": "GET",
      "p": "/api/analytics/reports/runs/{id}",
      "a": "GetRun",
      "k": "obj",
      "perm": "Reports"
     },
     {
      "m": "GET",
      "p": "/api/analytics/reports/runs/{id}/download",
      "a": "Download",
      "k": "file",
      "perm": "Reports"
     }
    ]
   },
   {
    "key": "Export",
    "label": "Exports",
    "eps": [
     {
      "m": "GET",
      "p": "/api/analytics/export/jobs",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "Export"
     },
     {
      "m": "GET",
      "p": "/api/analytics/export/jobs/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "Export"
     },
     {
      "m": "POST",
      "p": "/api/analytics/export/jobs",
      "a": "Create",
      "k": "obj",
      "h": "Unmasked phone numbers (maskNumbers = false) need the analytics.pii permission.",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "format",
        "t": "s",
        "d": "csv"
       },
       {
        "n": "gzip",
        "t": "b"
       },
       {
        "n": "maskNumbers",
        "t": "b",
        "d": true
       },
       {
        "n": "from",
        "t": "dt",
        "r": 1
       },
       {
        "n": "to",
        "t": "dt",
        "r": 1
       },
       {
        "n": "filters",
        "t": "j"
       }
      ],
      "perm": "Export"
     },
     {
      "m": "DELETE",
      "p": "/api/analytics/export/jobs/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Export"
     },
     {
      "m": "GET",
      "p": "/api/analytics/export/jobs/{id}/download",
      "a": "Download",
      "k": "file",
      "h": "Redirects to a short lived link of the object store, or streams the file when the store cannot presign.",
      "perm": "Export"
     },
     {
      "m": "GET",
      "p": "/api/analytics/export/calls.ndjson",
      "a": "StreamNdjson",
      "k": "none",
      "h": "Streams calls as newline delimited JSON. Query: range= | from=&amp;to=, mask=true|false, plus any filter field.",
      "q": [
       {
        "n": "range",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "timezone",
        "t": "s"
       },
       {
        "n": "mask",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Export"
     },
     {
      "m": "GET",
      "p": "/api/analytics/export/calls.csv",
      "a": "StreamCsv",
      "k": "file",
      "q": [
       {
        "n": "range",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "timezone",
        "t": "s"
       },
       {
        "n": "mask",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Export"
     }
    ]
   },
   {
    "key": "Spend",
    "label": "Ad spend",
    "eps": [
     {
      "m": "GET",
      "p": "/api/analytics/spend",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "query",
        "t": "j"
       }
      ],
      "perm": "Spend"
     },
     {
      "m": "GET",
      "p": "/api/analytics/spend/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "Spend"
     },
     {
      "m": "POST",
      "p": "/api/analytics/spend",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "date",
        "t": "dt",
        "r": 1
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "channel",
        "t": "s"
       },
       {
        "n": "amount",
        "t": "n"
       },
       {
        "n": "currency",
        "t": "s",
        "r": 1,
        "d": "USD"
       },
       {
        "n": "clicks",
        "t": "n"
       },
       {
        "n": "impressions",
        "t": "n"
       },
       {
        "n": "note",
        "t": "s"
       },
       {
        "n": "externalRef",
        "t": "s"
       }
      ],
      "perm": "Spend"
     },
     {
      "m": "PUT",
      "p": "/api/analytics/spend/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "date",
        "t": "dt",
        "r": 1
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "sourceId",
        "t": "g"
       },
       {
        "n": "channel",
        "t": "s"
       },
       {
        "n": "amount",
        "t": "n"
       },
       {
        "n": "currency",
        "t": "s",
        "r": 1,
        "d": "USD"
       },
       {
        "n": "clicks",
        "t": "n"
       },
       {
        "n": "impressions",
        "t": "n"
       },
       {
        "n": "note",
        "t": "s"
       },
       {
        "n": "externalRef",
        "t": "s"
       }
      ],
      "perm": "Spend"
     },
     {
      "m": "DELETE",
      "p": "/api/analytics/spend/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Spend"
     },
     {
      "m": "POST",
      "p": "/api/analytics/spend/import",
      "a": "Import",
      "k": "obj",
      "h": "CSV import (multipart field \"file\", max 2 MB / 5000 rows). Header: date, amount, currency, campaign_id, source_id, channel, clicks, impressions, note, external_ref. Re-importing the same rows updates ",
      "x": 1,
      "perm": "Spend"
     }
    ]
   },
   {
    "key": "Live",
    "label": "Live",
    "eps": [
     {
      "m": "GET",
      "p": "/api/analytics/live",
      "a": "Get",
      "k": "obj",
      "h": "The live board: calls in progress, queues, agent presence and today's KPIs against yesterday and last week. The same payload is pushed to the tenant's SignalR group as \"liveDashboard\" every couple of ",
      "q": [
       {
        "n": "timezone",
        "t": "s"
       }
      ],
      "perm": "Live"
     }
    ]
   },
   {
    "key": "Schema",
    "label": "Schema",
    "eps": [
     {
      "m": "GET",
      "p": "/api/analytics/schema",
      "a": "Get",
      "k": "obj",
      "h": "Dimensions, metrics, filters, operators and relative ranges the report builder offers.",
      "perm": "View"
     }
    ]
   }
  ]
 },
 {
  "key": "compliance",
  "label": "Compliance",
  "icon": "M12 3l8 3v6c0 4.5-3.2 7.8-8 9-4.8-1.2-8-4.5-8-9V6zM9 12l2 2 4-4",
  "sections": [
   {
    "key": "Reporting",
    "label": "Overview",
    "eps": [
     {
      "m": "GET",
      "p": "/api/compliance/dashboard",
      "a": "Dashboard",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/compliance/posture",
      "a": "Posture",
      "k": "obj",
      "perm": "AuditView"
     },
     {
      "m": "GET",
      "p": "/api/compliance/audit",
      "a": "Audit",
      "k": "paged",
      "q": [
       {
        "n": "query",
        "t": "j"
       }
      ],
      "perm": "AuditView"
     },
     {
      "m": "GET",
      "p": "/api/compliance/audit/actions",
      "a": "Actions",
      "k": "list",
      "perm": "AuditView"
     },
     {
      "m": "GET",
      "p": "/api/compliance/audit/export.csv",
      "a": "Export",
      "k": "file",
      "h": "The filtered audit trail as CSV (newest first, capped at the configured maximum). The export itself is audited.",
      "q": [
       {
        "n": "query",
        "t": "j"
       }
      ],
      "perm": "AuditView"
     }
    ]
   },
   {
    "key": "Dnc",
    "label": "Do not call",
    "eps": [
     {
      "m": "GET",
      "p": "/api/compliance/dnc",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "query",
        "t": "j"
       }
      ],
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/compliance/dnc",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "number",
        "t": "s",
        "r": 1
       },
       {
        "n": "reason",
        "t": "s"
       },
       {
        "n": "expiresAt",
        "t": "dt",
        "h": "When the number may be called again. Blank = never."
       }
      ],
      "perm": "DncManage"
     },
     {
      "m": "DELETE",
      "p": "/api/compliance/dnc/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "DncManage"
     },
     {
      "m": "POST",
      "p": "/api/compliance/dnc/check",
      "a": "Check",
      "k": "obj",
      "h": "Which of the numbers are on the list (body: { \"numbers\": [...] }, up to the configured maximum).",
      "b": [
       {
        "n": "numbers",
        "t": "sa"
       }
      ],
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/compliance/dnc/import",
      "a": "Import",
      "k": "obj",
      "h": "CSV import (multipart field \"file\"): one number per line, optional columns number,reason,expires_at.",
      "x": 1,
      "perm": "DncManage"
     },
     {
      "m": "GET",
      "p": "/api/compliance/dnc/export",
      "a": "Export",
      "k": "file",
      "perm": "DncManage"
     }
    ]
   },
   {
    "key": "Consent",
    "label": "Consent",
    "eps": [
     {
      "m": "GET",
      "p": "/api/compliance/consent/rules",
      "a": "Rules",
      "k": "paged",
      "q": [
       {
        "n": "country",
        "t": "s"
       },
       {
        "n": "overrides",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/compliance/consent/rules/{id}",
      "a": "Rule",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/compliance/consent/rules",
      "a": "CreateRule",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "country",
        "t": "s",
        "h": "ISO-3166 alpha-2 country. Blank = every country."
       },
       {
        "n": "region",
        "t": "s",
        "h": "State or province code. Needs a country."
       },
       {
        "n": "direction",
        "t": "s",
        "o": [
         "any",
         "inbound",
         "outbound"
        ],
        "d": "any",
        "h": "any | inbound | outbound"
       },
       {
        "n": "campaignId",
        "t": "g",
        "h": "A rule with a campaign or a queue is an override: it wins over the jurisdiction rules."
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "mode",
        "t": "s",
        "r": 1,
        "o": [
         "one_party",
         "two_party",
         "announce"
        ],
        "d": "one_party",
        "h": "one_party | two_party | announce"
       },
       {
        "n": "announcementText",
        "t": "s"
       },
       {
        "n": "language",
        "t": "s"
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "ConsentManage"
     },
     {
      "m": "PUT",
      "p": "/api/compliance/consent/rules/{id}",
      "a": "UpdateRule",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "country",
        "t": "s",
        "h": "ISO-3166 alpha-2 country. Blank = every country."
       },
       {
        "n": "region",
        "t": "s",
        "h": "State or province code. Needs a country."
       },
       {
        "n": "direction",
        "t": "s",
        "o": [
         "any",
         "inbound",
         "outbound"
        ],
        "d": "any",
        "h": "any | inbound | outbound"
       },
       {
        "n": "campaignId",
        "t": "g",
        "h": "A rule with a campaign or a queue is an override: it wins over the jurisdiction rules."
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "mode",
        "t": "s",
        "r": 1,
        "o": [
         "one_party",
         "two_party",
         "announce"
        ],
        "d": "one_party",
        "h": "one_party | two_party | announce"
       },
       {
        "n": "announcementText",
        "t": "s"
       },
       {
        "n": "language",
        "t": "s"
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "ConsentManage"
     },
     {
      "m": "DELETE",
      "p": "/api/compliance/consent/rules/{id}",
      "a": "DeleteRule",
      "k": "none",
      "perm": "ConsentManage"
     },
     {
      "m": "POST",
      "p": "/api/compliance/consent/evaluate",
      "a": "Evaluate",
      "k": "obj",
      "h": "What would happen for a call from this country / state to this campaign or queue (also used by the rule editor's tester).",
      "b": [
       {
        "n": "direction",
        "t": "s",
        "d": "inbound"
       },
       {
        "n": "callerCountry",
        "t": "s",
        "h": "ISO-3166 alpha-2 country of the caller (derived from the number)."
       },
       {
        "n": "callerRegion",
        "t": "s"
       },
       {
        "n": "calledCountry",
        "t": "s",
        "h": "Country of the party being called or the tracking number."
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "language",
        "t": "s"
       }
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/compliance/consent/records",
      "a": "Records",
      "k": "paged",
      "q": [
       {
        "n": "query",
        "t": "j"
       }
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/compliance/consent/summary",
      "a": "Summary",
      "k": "obj",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "perm": "View"
     }
    ]
   },
   {
    "key": "Retention",
    "label": "Retention",
    "eps": [
     {
      "m": "GET",
      "p": "/api/compliance/retention/policies",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "dataClass",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/compliance/retention/policies/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/compliance/retention/policies",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "dataClass",
        "t": "s",
        "r": 1,
        "o": [
         "recording",
         "voicemail",
         "transcript",
         "call"
        ],
        "d": "recording",
        "h": "recording | voicemail | transcript | call"
       },
       {
        "n": "days",
        "t": "n",
        "d": 365,
        "h": "Data older than this many days is removed."
       },
       {
        "n": "action",
        "t": "s",
        "r": 1,
        "o": [
         "delete",
         "anonymise"
        ],
        "d": "delete",
        "h": "delete | anonymise (anonymise removes personal data from call records and keeps the statistics)"
       },
       {
        "n": "campaignId",
        "t": "g",
        "h": "Limits the policy to one campaign and/or queue. A scoped policy cannot keep data longer than the organisation-wide policy."
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "RetentionManage"
     },
     {
      "m": "PUT",
      "p": "/api/compliance/retention/policies/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "dataClass",
        "t": "s",
        "r": 1,
        "o": [
         "recording",
         "voicemail",
         "transcript",
         "call"
        ],
        "d": "recording",
        "h": "recording | voicemail | transcript | call"
       },
       {
        "n": "days",
        "t": "n",
        "d": 365,
        "h": "Data older than this many days is removed."
       },
       {
        "n": "action",
        "t": "s",
        "r": 1,
        "o": [
         "delete",
         "anonymise"
        ],
        "d": "delete",
        "h": "delete | anonymise (anonymise removes personal data from call records and keeps the statistics)"
       },
       {
        "n": "campaignId",
        "t": "g",
        "h": "Limits the policy to one campaign and/or queue. A scoped policy cannot keep data longer than the organisation-wide policy."
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "RetentionManage"
     },
     {
      "m": "DELETE",
      "p": "/api/compliance/retention/policies/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "RetentionManage"
     },
     {
      "m": "POST",
      "p": "/api/compliance/retention/policies/{id}/preview",
      "a": "Preview",
      "k": "obj",
      "h": "Counts what the policy would remove right now, without removing anything.",
      "perm": "RetentionManage"
     },
     {
      "m": "POST",
      "p": "/api/compliance/retention/policies/{id}/run",
      "a": "Run",
      "k": "none",
      "h": "Schedules the policy to run now (the retention worker picks it up within a minute).",
      "perm": "RetentionManage"
     },
     {
      "m": "GET",
      "p": "/api/compliance/retention/runs",
      "a": "Runs",
      "k": "paged",
      "q": [
       {
        "n": "query",
        "t": "j"
       }
      ],
      "perm": "View"
     }
    ]
   },
   {
    "key": "Holds",
    "label": "Legal holds",
    "eps": [
     {
      "m": "GET",
      "p": "/api/compliance/holds",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/compliance/holds/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/compliance/holds",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "caseNumber",
        "t": "s"
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "criteria",
        "t": "j",
        "h": "Leave empty for a hold that only covers calls added by hand."
       }
      ],
      "perm": "HoldsManage"
     },
     {
      "m": "PUT",
      "p": "/api/compliance/holds/{id}",
      "a": "Update",
      "k": "obj",
      "h": "Only a draft can be edited.",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "caseNumber",
        "t": "s"
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "criteria",
        "t": "j",
        "h": "Leave empty for a hold that only covers calls added by hand."
       }
      ],
      "perm": "HoldsManage"
     },
     {
      "m": "DELETE",
      "p": "/api/compliance/holds/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "HoldsManage"
     },
     {
      "m": "POST",
      "p": "/api/compliance/holds/{id}/activate",
      "a": "Activate",
      "k": "obj",
      "perm": "HoldsManage"
     },
     {
      "m": "POST",
      "p": "/api/compliance/holds/{id}/release",
      "a": "Release",
      "k": "obj",
      "b": [
       {
        "n": "reason",
        "t": "s",
        "r": 1
       }
      ],
      "perm": "HoldsManage"
     },
     {
      "m": "POST",
      "p": "/api/compliance/holds/{id}/calls",
      "a": "AddCalls",
      "k": "obj",
      "b": [
       {
        "n": "callIds",
        "t": "ga",
        "r": 1
       }
      ],
      "perm": "HoldsManage"
     },
     {
      "m": "GET",
      "p": "/api/compliance/holds/{id}/calls",
      "a": "Calls",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     }
    ]
   },
   {
    "key": "Privacy",
    "label": "Privacy requests",
    "eps": [
     {
      "m": "GET",
      "p": "/api/compliance/privacy/requests",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "query",
        "t": "j"
       }
      ],
      "perm": "PrivacyManage"
     },
     {
      "m": "GET",
      "p": "/api/compliance/privacy/requests/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "PrivacyManage"
     },
     {
      "m": "POST",
      "p": "/api/compliance/privacy/requests",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "type",
        "t": "s",
        "r": 1,
        "o": [
         "access",
         "portability",
         "erasure",
         "restriction",
         "withdrawal"
        ],
        "d": "access",
        "h": "access | portability | erasure | restriction | withdrawal"
       },
       {
        "n": "framework",
        "t": "s",
        "r": 1,
        "o": [
         "gdpr",
         "ccpa",
         "ndpr",
         "other"
        ],
        "d": "gdpr",
        "h": "gdpr | ccpa | ndpr | other: decides the legal deadline."
       },
       {
        "n": "subjectName",
        "t": "s"
       },
       {
        "n": "subjectEmail",
        "t": "s"
       },
       {
        "n": "subjectNumbers",
        "t": "sa",
        "r": 1,
        "h": "Phone numbers of the data subject (1 to 10)."
       },
       {
        "n": "receivedAt",
        "t": "dt",
        "h": "When the request reached the organisation (the deadline counts from here). Default: now."
       },
       {
        "n": "notes",
        "t": "s"
       },
       {
        "n": "addToDnc",
        "t": "b",
        "h": "Keep the numbers on the do-not-call list after an erasure (restriction and withdrawal always do)."
       }
      ],
      "perm": "PrivacyManage"
     },
     {
      "m": "PUT",
      "p": "/api/compliance/privacy/requests/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "subjectName",
        "t": "s"
       },
       {
        "n": "subjectEmail",
        "t": "s"
       },
       {
        "n": "subjectNumbers",
        "t": "sa",
        "h": "Only while the request is open or verified."
       },
       {
        "n": "notes",
        "t": "s"
       },
       {
        "n": "addToDnc",
        "t": "b"
       }
      ],
      "perm": "PrivacyManage"
     },
     {
      "m": "POST",
      "p": "/api/compliance/privacy/requests/{id}/verify",
      "a": "Verify",
      "k": "obj",
      "h": "Confirms the identity of the data subject. Nothing is executed before this.",
      "b": [
       {
        "n": "method",
        "t": "s",
        "r": 1,
        "h": "How the identity of the data subject was confirmed (for example \"email link\", \"ID document\", \"account login\")."
       }
      ],
      "perm": "PrivacyManage"
     },
     {
      "m": "POST",
      "p": "/api/compliance/privacy/requests/{id}/reject",
      "a": "Reject",
      "k": "obj",
      "b": [
       {
        "n": "reason",
        "t": "s",
        "r": 1
       }
      ],
      "perm": "PrivacyManage"
     },
     {
      "m": "POST",
      "p": "/api/compliance/privacy/requests/{id}/process",
      "a": "Process",
      "k": "obj",
      "h": "Starts the execution of a verified request (or restarts one that stalled). The privacy worker does the work.",
      "perm": "PrivacyProcess"
     },
     {
      "m": "GET",
      "p": "/api/compliance/privacy/requests/{id}/results",
      "a": "Results",
      "k": "list",
      "perm": "PrivacyManage"
     },
     {
      "m": "GET",
      "p": "/api/compliance/privacy/requests/{id}/export",
      "a": "Export",
      "k": "file",
      "h": "The data package of an access or portability request. Every download is audited.",
      "perm": "PrivacyProcess"
     }
    ]
   },
   {
    "key": "Pci",
    "label": "PCI",
    "eps": [
     {
      "m": "GET",
      "p": "/api/compliance/pci/settings",
      "a": "Settings",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "PUT",
      "p": "/api/compliance/pci/settings",
      "a": "UpdateSettings",
      "k": "obj",
      "b": [
       {
        "n": "enabled",
        "t": "b",
        "d": true
       },
       {
        "n": "pauseOnPci",
        "t": "b",
        "d": true,
        "h": "Pause the recording while card details are spoken."
       },
       {
        "n": "maxPauseSeconds",
        "t": "n",
        "d": 120,
        "h": "A pause longer than this is resumed automatically and reported as a stale pause."
       },
       {
        "n": "promptKeywords",
        "t": "sa"
       },
       {
        "n": "redactTranscripts",
        "t": "b",
        "d": true
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "PciManage"
     },
     {
      "m": "GET",
      "p": "/api/compliance/pci/events",
      "a": "Events",
      "k": "paged",
      "q": [
       {
        "n": "query",
        "t": "j"
       }
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/compliance/pci/summary",
      "a": "Summary",
      "k": "obj",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "perm": "View"
     }
    ]
   },
   {
    "key": "Residency",
    "label": "Residency",
    "eps": [
     {
      "m": "GET",
      "p": "/api/compliance/residency/profile",
      "a": "Profile",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "PUT",
      "p": "/api/compliance/residency/profile",
      "a": "UpdateProfile",
      "k": "obj",
      "b": [
       {
        "n": "country",
        "t": "s",
        "h": "ISO-3166 alpha-2 country used to read national phone numbers (blank = platform default)."
       },
       {
        "n": "dataResidency",
        "t": "s",
        "h": "Region code of the storage region that holds this organisation's data (blank = default region)."
       },
       {
        "n": "privacyEmail",
        "t": "s",
        "h": "Where overdue and due-soon privacy request alerts go."
       }
      ],
      "perm": "ResidencyManage"
     },
     {
      "m": "GET",
      "p": "/api/compliance/residency/regions",
      "a": "Regions",
      "k": "list",
      "h": "The region codes this deployment can store data in.",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/compliance/residency/policies",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/compliance/residency/policies/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/compliance/residency/policies",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "dataClass",
        "t": "s",
        "r": 1,
        "o": [
         "recording",
         "transcript",
         "call",
         "export"
        ],
        "d": "*",
        "h": "* (everything) | recording | transcript | call | export"
       },
       {
        "n": "region",
        "t": "s",
        "r": 1,
        "h": "A storage region configured on the platform (for example eu, ng, us)."
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "ResidencyManage"
     },
     {
      "m": "PUT",
      "p": "/api/compliance/residency/policies/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "dataClass",
        "t": "s",
        "r": 1,
        "o": [
         "recording",
         "transcript",
         "call",
         "export"
        ],
        "d": "*",
        "h": "* (everything) | recording | transcript | call | export"
       },
       {
        "n": "region",
        "t": "s",
        "r": 1,
        "h": "A storage region configured on the platform (for example eu, ng, us)."
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "notes",
        "t": "s"
       }
      ],
      "perm": "ResidencyManage"
     },
     {
      "m": "DELETE",
      "p": "/api/compliance/residency/policies/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "ResidencyManage"
     }
    ]
   },
   {
    "key": "Discovery",
    "label": "Discovery",
    "eps": [
     {
      "m": "GET",
      "p": "/api/compliance/discovery/exports",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "DiscoveryExport"
     },
     {
      "m": "GET",
      "p": "/api/compliance/discovery/exports/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "DiscoveryExport"
     },
     {
      "m": "POST",
      "p": "/api/compliance/discovery/exports",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "caseNumber",
        "t": "s"
       },
       {
        "n": "holdId",
        "t": "g",
        "h": "Export the calls held by this legal hold (and/or the calls matching the criteria)."
       },
       {
        "n": "criteria",
        "t": "j"
       },
       {
        "n": "includeCalls",
        "t": "b",
        "d": true
       },
       {
        "n": "includeTranscripts",
        "t": "b",
        "d": true
       },
       {
        "n": "includeAudio",
        "t": "b",
        "d": true
       }
      ],
      "perm": "DiscoveryExport"
     },
     {
      "m": "POST",
      "p": "/api/compliance/discovery/exports/{id}/cancel",
      "a": "Cancel",
      "k": "obj",
      "perm": "DiscoveryExport"
     },
     {
      "m": "DELETE",
      "p": "/api/compliance/discovery/exports/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "DiscoveryExport"
     },
     {
      "m": "GET",
      "p": "/api/compliance/discovery/exports/{id}/custody",
      "a": "Custody",
      "k": "list",
      "perm": "DiscoveryExport"
     },
     {
      "m": "GET",
      "p": "/api/compliance/discovery/exports/{id}/download",
      "a": "Download",
      "k": "file",
      "h": "Redirects to a short lived link of the object store, or streams the ZIP when the store cannot sign links. Logged in the chain of custody.",
      "perm": "DiscoveryExport"
     }
    ]
   }
  ]
 },
 {
  "key": "integrations",
  "label": "Integrations",
  "icon": "M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1M14 10a4 4 0 00-5.7 0l-3 3A4 4 0 0011 18.7l1-1",
  "sections": [
   {
    "key": "Connections",
    "label": "Connections",
    "eps": [
     {
      "m": "GET",
      "p": "/api/integrations/providers",
      "a": "Providers",
      "k": "list",
      "q": [
       {
        "n": "category",
        "t": "s"
       }
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/integrations/connections",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "category",
        "t": "s"
       },
       {
        "n": "provider",
        "t": "s"
       },
       {
        "n": "status",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/integrations/connections/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/integrations/connections",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "provider",
        "t": "s",
        "r": 1
       },
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "fields",
        "t": "j",
        "h": "Every field of the provider form, secret or not. The service decides what is encrypted."
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "isEnabled",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Connect"
     },
     {
      "m": "PUT",
      "p": "/api/integrations/connections/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s"
       },
       {
        "n": "fields",
        "t": "j",
        "h": "Fields to change. A secret field that is missing or blank keeps its stored value."
       },
       {
        "n": "priority",
        "t": "n"
       },
       {
        "n": "isEnabled",
        "t": "b"
       }
      ],
      "perm": "Connect"
     },
     {
      "m": "DELETE",
      "p": "/api/integrations/connections/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Connect"
     },
     {
      "m": "POST",
      "p": "/api/integrations/connections/{id}/test",
      "a": "Test",
      "k": "obj",
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/integrations/connections/{id}/regenerate-key",
      "a": "RegenerateKey",
      "k": "obj",
      "h": "New unguessable key for the ingest URL; the old URL stops working immediately.",
      "perm": "Connect"
     },
     {
      "m": "POST",
      "p": "/api/integrations/connections/{id}/oauth/start",
      "a": "StartOAuth",
      "k": "obj",
      "perm": "Connect"
     }
    ]
   },
   {
    "key": "Webhooks",
    "label": "Webhooks",
    "eps": [
     {
      "m": "GET",
      "p": "/api/integrations/webhooks",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "source",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/integrations/webhooks/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/integrations/webhooks",
      "a": "Create",
      "k": "obj",
      "h": "The signing secret is part of this answer and never shown again; rotate it to get a new one.",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "url",
        "t": "s",
        "r": 1
       },
       {
        "n": "eventTypes",
        "t": "sa",
        "h": "Event types; \"*\" or \"call.*\" wildcards are allowed. Empty means every event."
       },
       {
        "n": "headers",
        "t": "j"
       },
       {
        "n": "filters",
        "t": "j"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Webhooks"
     },
     {
      "m": "PUT",
      "p": "/api/integrations/webhooks/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "url",
        "t": "s",
        "r": 1
       },
       {
        "n": "eventTypes",
        "t": "sa",
        "h": "Event types; \"*\" or \"call.*\" wildcards are allowed. Empty means every event."
       },
       {
        "n": "headers",
        "t": "j"
       },
       {
        "n": "filters",
        "t": "j"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Webhooks"
     },
     {
      "m": "DELETE",
      "p": "/api/integrations/webhooks/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Webhooks"
     },
     {
      "m": "POST",
      "p": "/api/integrations/webhooks/{id}/rotate-secret",
      "a": "Rotate",
      "k": "obj",
      "perm": "Webhooks"
     },
     {
      "m": "POST",
      "p": "/api/integrations/webhooks/{id}/enable",
      "a": "Enable",
      "k": "obj",
      "h": "Switches a webhook on again after it was disabled automatically.",
      "perm": "Webhooks"
     },
     {
      "m": "POST",
      "p": "/api/integrations/webhooks/{id}/test",
      "a": "Test",
      "k": "obj",
      "perm": "Webhooks"
     },
     {
      "m": "GET",
      "p": "/api/integrations/webhooks/{id}/deliveries",
      "a": "Deliveries",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "eventType",
        "t": "s"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/integrations/webhooks/{id}/replay",
      "a": "Replay",
      "k": "obj",
      "b": [
       {
        "n": "deliveryId",
        "t": "g",
        "h": "One delivery to send again. Without it every dead letter of the webhook is replayed."
       },
       {
        "n": "since",
        "t": "dt"
       }
      ],
      "perm": "Replay"
     }
    ]
   },
   {
    "key": "Rules",
    "label": "Rules",
    "eps": [
     {
      "m": "GET",
      "p": "/api/integrations/rules/catalog",
      "a": "Catalog",
      "k": "list",
      "h": "Events, actions and condition operators the rule editor offers.",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/integrations/rules",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "eventType",
        "t": "s"
       },
       {
        "n": "action",
        "t": "s"
       },
       {
        "n": "connectionId",
        "t": "g"
       },
       {
        "n": "active",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/integrations/rules/{id}",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/integrations/rules",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "eventType",
        "t": "s",
        "r": 1
       },
       {
        "n": "action",
        "t": "s",
        "r": 1
       },
       {
        "n": "connectionId",
        "t": "g"
       },
       {
        "n": "filters",
        "t": "j",
        "h": "[{ \"field\": \"durationSeconds\", \"op\": \"gte\", \"value\": 30 }] evaluated against the event payload."
       },
       {
        "n": "config",
        "t": "j"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "delaySeconds",
        "t": "n"
       }
      ],
      "perm": "Rules"
     },
     {
      "m": "PUT",
      "p": "/api/integrations/rules/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "eventType",
        "t": "s",
        "r": 1
       },
       {
        "n": "action",
        "t": "s",
        "r": 1
       },
       {
        "n": "connectionId",
        "t": "g"
       },
       {
        "n": "filters",
        "t": "j",
        "h": "[{ \"field\": \"durationSeconds\", \"op\": \"gte\", \"value\": 30 }] evaluated against the event payload."
       },
       {
        "n": "config",
        "t": "j"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "delaySeconds",
        "t": "n"
       }
      ],
      "perm": "Rules"
     },
     {
      "m": "DELETE",
      "p": "/api/integrations/rules/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Rules"
     },
     {
      "m": "POST",
      "p": "/api/integrations/rules/{id}/test",
      "a": "Test",
      "k": "obj",
      "h": "Evaluates a rule against a sample or supplied payload without sending anything.",
      "b": [
       {
        "n": "payload",
        "t": "j",
        "r": 1,
        "h": "A payload shaped like the event, for example a call.ended event."
       }
      ],
      "perm": "Rules"
     },
     {
      "m": "POST",
      "p": "/api/integrations/rules/defaults/{connectionId}",
      "a": "Defaults",
      "k": "list",
      "h": "Creates the recommended rules for a freshly connected CRM, helpdesk, ad platform or notification channel.",
      "perm": "Rules"
     }
    ]
   },
   {
    "key": "Outbox",
    "label": "Outbox",
    "eps": [
     {
      "m": "GET",
      "p": "/api/integrations/outbox",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "kind",
        "t": "s"
       },
       {
        "n": "connectionId",
        "t": "g"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/integrations/outbox/replay",
      "a": "Replay",
      "k": "obj",
      "h": "Puts failed or dead items (selected by id, connection or status) back in the queue.",
      "b": [
       {
        "n": "connectionId",
        "t": "g"
       },
       {
        "n": "kind",
        "t": "s"
       },
       {
        "n": "statuses",
        "t": "sa",
        "h": "Defaults to failed and dead."
       },
       {
        "n": "since",
        "t": "dt"
       },
       {
        "n": "ids",
        "t": "ga"
       },
       {
        "n": "limit",
        "t": "n",
        "d": 1000
       }
      ],
      "perm": "Replay"
     },
     {
      "m": "POST",
      "p": "/api/integrations/outbox/{id}/cancel",
      "a": "Cancel",
      "k": "none",
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/integrations/deliveries",
      "a": "Deliveries",
      "k": "paged",
      "q": [
       {
        "n": "connectionId",
        "t": "g"
       },
       {
        "n": "success",
        "t": "b"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/integrations/notifications/test",
      "a": "TestNotification",
      "k": "obj",
      "b": [
       {
        "n": "channel",
        "t": "s",
        "r": 1,
        "d": "email"
       },
       {
        "n": "to",
        "t": "sa"
       },
       {
        "n": "connectionId",
        "t": "g"
       },
       {
        "n": "subject",
        "t": "s",
        "d": "Cilpron test notification"
       },
       {
        "n": "body",
        "t": "s",
        "d": "This is a test notification from Cilpron Calls."
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/integrations/sms-opt-outs",
      "a": "OptOuts",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/integrations/sms-opt-outs",
      "a": "AddOptOut",
      "k": "obj",
      "b": [
       {
        "n": "number",
        "t": "s",
        "r": 1
       },
       {
        "n": "reason",
        "t": "s"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/integrations/sms-opt-outs/{id}",
      "a": "RemoveOptOut",
      "k": "none",
      "perm": "Manage"
     }
    ]
   },
   {
    "key": "Exports",
    "label": "Exports",
    "eps": [
     {
      "m": "GET",
      "p": "/api/integrations/exports/datasets",
      "a": "Datasets",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/integrations/exports",
      "a": "List",
      "k": "paged",
      "q": [],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     },
     {
      "m": "PUT",
      "p": "/api/integrations/exports",
      "a": "Upsert",
      "k": "obj",
      "b": [
       {
        "n": "connectionId",
        "t": "g",
        "r": 1
       },
       {
        "n": "dataset",
        "t": "s",
        "r": 1,
        "o": [
         "calls",
         "conversions",
         "voicemails",
         "quality",
         "events"
        ],
        "d": "calls",
        "h": "calls | conversions | voicemails | quality | events"
       },
       {
        "n": "format",
        "t": "s",
        "o": [
         "ndjson",
         "csv"
        ],
        "d": "ndjson",
        "h": "ndjson | csv"
       },
       {
        "n": "intervalMinutes",
        "t": "n",
        "d": 60
       },
       {
        "n": "isEnabled",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "DELETE",
      "p": "/api/integrations/exports/{id}",
      "a": "Delete",
      "k": "none",
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/integrations/exports/{id}/run",
      "a": "RunNow",
      "k": "none",
      "h": "Makes the checkpoint due now; the export worker picks it up within a minute.",
      "perm": "Manage"
     }
    ]
   },
   {
    "key": "Hooks",
    "label": "Hooks",
    "eps": [
     {
      "m": "GET",
      "p": "/api/integrations/hooks/me",
      "a": "Me",
      "k": "obj",
      "h": "Authentication test used when a user connects the automation platform account.",
      "perm": "Webhooks"
     },
     {
      "m": "GET",
      "p": "/api/integrations/hooks/events",
      "a": "Events",
      "k": "list",
      "perm": "Webhooks"
     },
     {
      "m": "POST",
      "p": "/api/integrations/hooks/subscribe",
      "a": "Subscribe",
      "k": "obj",
      "b": [
       {
        "n": "targetUrl",
        "t": "s",
        "r": 1
       },
       {
        "n": "event",
        "t": "s",
        "r": 1
       },
       {
        "n": "name",
        "t": "s"
       },
       {
        "n": "platform",
        "t": "s",
        "o": [
         "zapier",
         "make",
         "n8n",
         "workato",
         "other"
        ],
        "h": "zapier | make | n8n | workato | other (informational)"
       },
       {
        "n": "filters",
        "t": "j"
       }
      ],
      "perm": "Webhooks"
     },
     {
      "m": "DELETE",
      "p": "/api/integrations/hooks/subscribe/{id}",
      "a": "Unsubscribe",
      "k": "none",
      "perm": "Webhooks"
     },
     {
      "m": "GET",
      "p": "/api/integrations/hooks/sample/{eventType}",
      "a": "Sample",
      "k": "list",
      "h": "A typical payload of the event, so that the automation platform can map its fields.",
      "perm": "Webhooks"
     },
     {
      "m": "GET",
      "p": "/api/integrations/hooks/recent/{eventType}",
      "a": "Recent",
      "k": "list",
      "h": "Polling trigger: the newest real events of the type, newest first.",
      "q": [
       {
        "n": "limit",
        "t": "n",
        "d": 25
       }
      ],
      "perm": "Webhooks"
     }
    ]
   },
   {
    "key": "AgentTools",
    "label": "Agent tools",
    "eps": [
     {
      "m": "GET",
      "p": "/api/integrations/click-to-dial/meta",
      "a": "Meta",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/integrations/click-to-dial",
      "a": "Dial",
      "k": "obj",
      "h": "Rings the agent first and then the customer. Checked against the do-not-call list before anything is dialled.",
      "b": [
       {
        "n": "to",
        "t": "s",
        "r": 1
       },
       {
        "n": "fromNumberId",
        "t": "g"
       },
       {
        "n": "fromNumber",
        "t": "s"
       },
       {
        "n": "agentId",
        "t": "g"
       },
       {
        "n": "agentSipUsername",
        "t": "s"
       },
       {
        "n": "agentNumber",
        "t": "s"
       },
       {
        "n": "campaignId",
        "t": "g"
       },
       {
        "n": "queueId",
        "t": "g"
       },
       {
        "n": "record",
        "t": "b",
        "d": true
       }
      ],
      "perm": "Lookup"
     },
     {
      "m": "GET",
      "p": "/api/integrations/screen-pop",
      "a": "ScreenPop",
      "k": "obj",
      "h": "Screen pop: the CRM record and open ticket of a phone number or e-mail address.",
      "q": [
       {
        "n": "phone",
        "t": "s"
       },
       {
        "n": "email",
        "t": "s"
       },
       {
        "n": "callId",
        "t": "g"
       }
      ],
      "perm": "Lookup"
     }
    ]
   },
   {
    "key": "Ingest",
    "label": "Ingest log",
    "eps": [
     {
      "m": "GET",
      "p": "/api/integrations/ingest/log",
      "a": "Log",
      "k": "paged",
      "q": [
       {
        "n": "connectionId",
        "t": "g"
       },
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "provider",
        "t": "s"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ],
      "perm": "View"
     }
    ]
   },
   {
    "key": "Health",
    "label": "Health",
    "eps": [
     {
      "m": "GET",
      "p": "/api/integrations/health",
      "a": "Summary",
      "k": "obj",
      "h": "Status, health score, last error and queue backlog of every connection.",
      "perm": "View"
     }
    ]
   }
  ]
 },
 {
  "key": "admin",
  "label": "Admin",
  "icon": "M12 15a3 3 0 100-6 3 3 0 000 6zM19 12l2-1-2-3-2 .6a7 7 0 00-1.6-1L15 5h-4l-.4 2.6a7 7 0 00-1.6 1L7 8l-2 3 2 1a7 7 0 000 2l-2 1 2 3 2-.6a7 7 0 001.6 1L11 21h4l.4-2.6a7 7 0 001.6-1l2 .6 2-3-2-1a7 7 0 000-2z",
  "sections": [
   {
    "key": "Tenants",
    "label": "Organisation",
    "eps": [
     {
      "m": "GET",
      "p": "/api/platform/tenants/current",
      "a": "Current",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "PUT",
      "p": "/api/platform/tenants/current/settings",
      "a": "UpdateSettings",
      "k": "obj",
      "h": "Settings: name, time zone, language, country, currency, default recording retention and contact details.",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "timezone",
        "t": "s"
       },
       {
        "n": "language",
        "t": "s"
       },
       {
        "n": "country",
        "t": "s"
       },
       {
        "n": "currency",
        "t": "s"
       },
       {
        "n": "recordingRetentionDays",
        "t": "n"
       },
       {
        "n": "contactEmail",
        "t": "s"
       },
       {
        "n": "contactPhone",
        "t": "s"
       },
       {
        "n": "website",
        "t": "s"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/platform/tenants/bootstrap",
      "a": "Bootstrap",
      "k": "obj",
      "h": "Registers the caller's organisation the first time it uses the platform. Safe to call again.",
      "b": [
       {
        "n": "name",
        "t": "s"
       },
       {
        "n": "contactEmail",
        "t": "s"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/platform/tenants/tree",
      "a": "Tree",
      "k": "obj",
      "h": "The organisation and everything below it with month-to-date usage rolled up the hierarchy.",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/platform/tenants/current/children",
      "a": "CreateChild",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "timezone",
        "t": "s"
       },
       {
        "n": "language",
        "t": "s"
       },
       {
        "n": "country",
        "t": "s"
       },
       {
        "n": "currency",
        "t": "s"
       },
       {
        "n": "recordingRetentionDays",
        "t": "n"
       },
       {
        "n": "contactEmail",
        "t": "s"
       },
       {
        "n": "contactPhone",
        "t": "s"
       },
       {
        "n": "website",
        "t": "s"
       }
      ],
      "perm": "Manage"
     },
     {
      "m": "POST",
      "p": "/api/platform/tenants/current/sandbox",
      "a": "Sandbox",
      "k": "obj",
      "h": "The sandbox organisation (created on first use) that holds test API keys and test data.",
      "perm": "Manage"
     },
     {
      "m": "GET",
      "p": "/api/platform/tenants/{id}",
      "a": "Get",
      "k": "obj",
      "h": "The caller's organisation or one below it (operators: any).",
      "perm": "View"
     }
    ]
   },
   {
    "key": "AdminTenants",
    "label": "Tenants",
    "eps": [
     {
      "m": "GET",
      "p": "/api/platform/admin/tenants",
      "a": "List",
      "k": "paged",
      "q": [
       {
        "n": "status",
        "t": "s"
       },
       {
        "n": "parentId",
        "t": "g"
       },
       {
        "n": "sandbox",
        "t": "b"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ]
     },
     {
      "m": "GET",
      "p": "/api/platform/admin/tenants/{id}",
      "a": "Get",
      "k": "obj"
     },
     {
      "m": "POST",
      "p": "/api/platform/admin/tenants",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "timezone",
        "t": "s"
       },
       {
        "n": "language",
        "t": "s"
       },
       {
        "n": "country",
        "t": "s"
       },
       {
        "n": "currency",
        "t": "s"
       },
       {
        "n": "recordingRetentionDays",
        "t": "n"
       },
       {
        "n": "contactEmail",
        "t": "s"
       },
       {
        "n": "contactPhone",
        "t": "s"
       },
       {
        "n": "website",
        "t": "s"
       },
       {
        "n": "tenantId",
        "t": "g",
        "h": "Explicit tenant id (the organisation id of central authentication). Optional."
       },
       {
        "n": "externalId",
        "t": "s",
        "h": "Organisation id of central authentication when it is not a GUID; the tenant id is derived from it."
       },
       {
        "n": "parentId",
        "t": "g"
       },
       {
        "n": "isSandbox",
        "t": "b"
       },
       {
        "n": "dataResidency",
        "t": "s"
       },
       {
        "n": "ratePlanId",
        "t": "g"
       }
      ]
     },
     {
      "m": "PUT",
      "p": "/api/platform/admin/tenants/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "timezone",
        "t": "s"
       },
       {
        "n": "language",
        "t": "s"
       },
       {
        "n": "country",
        "t": "s"
       },
       {
        "n": "currency",
        "t": "s"
       },
       {
        "n": "recordingRetentionDays",
        "t": "n"
       },
       {
        "n": "contactEmail",
        "t": "s"
       },
       {
        "n": "contactPhone",
        "t": "s"
       },
       {
        "n": "website",
        "t": "s"
       },
       {
        "n": "dataResidency",
        "t": "s"
       },
       {
        "n": "ratePlanId",
        "t": "g"
       },
       {
        "n": "externalId",
        "t": "s"
       }
      ]
     },
     {
      "m": "POST",
      "p": "/api/platform/admin/tenants/{id}/suspend",
      "a": "Suspend",
      "k": "obj",
      "b": [
       {
        "n": "reason",
        "t": "s",
        "r": 1
       }
      ]
     },
     {
      "m": "POST",
      "p": "/api/platform/admin/tenants/{id}/reactivate",
      "a": "Reactivate",
      "k": "obj"
     },
     {
      "m": "DELETE",
      "p": "/api/platform/admin/tenants/{id}",
      "a": "Close",
      "k": "obj",
      "h": "Closes the organisation for good (kept for billing and audit). Its API keys are revoked."
     },
     {
      "m": "PUT",
      "p": "/api/platform/admin/tenants/{id}/rate-plan",
      "a": "AssignRatePlan",
      "k": "obj",
      "b": [
       {
        "n": "ratePlanId",
        "t": "g"
       }
      ]
     }
    ]
   },
   {
    "key": "ApiKeys",
    "label": "API keys",
    "eps": [
     {
      "m": "GET",
      "p": "/api/platform/api-keys",
      "a": "List",
      "k": "list"
     },
     {
      "m": "GET",
      "p": "/api/platform/api-keys/{id}",
      "a": "Get",
      "k": "obj"
     },
     {
      "m": "POST",
      "p": "/api/platform/api-keys",
      "a": "Create",
      "k": "obj",
      "h": "The response contains the secret once; it cannot be read again.",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "scopes",
        "t": "sa",
        "r": 1
       },
       {
        "n": "expiresAt",
        "t": "dt"
       },
       {
        "n": "environment",
        "t": "s",
        "h": "\"live\" (default) or \"test\": test keys belong to the sandbox organisation and never touch production data."
       }
      ]
     },
     {
      "m": "PUT",
      "p": "/api/platform/api-keys/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       }
      ]
     },
     {
      "m": "POST",
      "p": "/api/platform/api-keys/{id}/rotate",
      "a": "Rotate",
      "k": "obj",
      "h": "Issues a replacement key; the old one keeps working for the grace period.",
      "b": [
       {
        "n": "graceHours",
        "t": "n",
        "h": "How long the old key keeps working after the new one exists (0 = revoke at once)."
       }
      ]
     },
     {
      "m": "POST",
      "p": "/api/platform/api-keys/{id}/revoke",
      "a": "Revoke",
      "k": "obj"
     },
     {
      "m": "GET",
      "p": "/api/platform/api-keys/{id}/usage",
      "a": "Usage",
      "k": "obj",
      "q": [
       {
        "n": "days",
        "t": "n",
        "d": 30
       }
      ]
     }
    ]
   },
   {
    "key": "Permissions",
    "label": "Permissions",
    "eps": [
     {
      "m": "GET",
      "p": "/api/platform/permissions/catalog",
      "a": "Catalog",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/platform/permissions/roles",
      "a": "Roles",
      "k": "list",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/platform/permissions/export",
      "a": "Export",
      "k": "file",
      "h": "The document central authentication imports (permissions with groups and descriptions, roles with their permissions).",
      "perm": "View"
     },
     {
      "m": "POST",
      "p": "/api/platform/permissions/sync",
      "a": "Sync",
      "k": "obj",
      "h": "Pushes the catalog to central authentication (Auth:BaseUrl + Platform:AuthSyncPath).",
      "perm": "Admin"
     }
    ]
   },
   {
    "key": "Branding",
    "label": "Branding",
    "eps": [
     {
      "m": "GET",
      "p": "/api/platform/branding",
      "a": "Get",
      "k": "obj",
      "perm": "View"
     },
     {
      "m": "PUT",
      "p": "/api/platform/branding",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "productName",
        "t": "s"
       },
       {
        "n": "colorPrimary",
        "t": "s"
       },
       {
        "n": "colorOnPrimary",
        "t": "s"
       },
       {
        "n": "colorAccent",
        "t": "s"
       },
       {
        "n": "colorOnAccent",
        "t": "s"
       },
       {
        "n": "colorBackground",
        "t": "s"
       },
       {
        "n": "colorText",
        "t": "s"
       },
       {
        "n": "supportEmail",
        "t": "s"
       },
       {
        "n": "supportUrl",
        "t": "s"
       },
       {
        "n": "footerText",
        "t": "s"
       },
       {
        "n": "emailFromName",
        "t": "s"
       }
      ],
      "perm": "Branding"
     },
     {
      "m": "POST",
      "p": "/api/platform/branding/logo",
      "a": "UploadLogo",
      "k": "obj",
      "h": "Logo upload (multipart field \"file\"; PNG, JPEG, GIF or WebP).",
      "x": 1,
      "perm": "Branding"
     },
     {
      "m": "DELETE",
      "p": "/api/platform/branding/logo",
      "a": "RemoveLogo",
      "k": "none",
      "perm": "Branding"
     },
     {
      "m": "GET",
      "p": "/api/platform/branding/logo",
      "a": "Logo",
      "k": "file",
      "perm": "View"
     },
     {
      "m": "GET",
      "p": "/api/platform/branding/domains",
      "a": "Domains",
      "k": "list",
      "perm": "Branding"
     },
     {
      "m": "POST",
      "p": "/api/platform/branding/domains",
      "a": "AddDomain",
      "k": "obj",
      "b": [
       {
        "n": "host",
        "t": "s",
        "r": 1
       }
      ],
      "perm": "Branding"
     },
     {
      "m": "POST",
      "p": "/api/platform/branding/domains/{id}/verify",
      "a": "VerifyDomain",
      "k": "obj",
      "h": "Checks the DNS TXT record immediately (the background worker also keeps checking).",
      "perm": "Branding"
     },
     {
      "m": "DELETE",
      "p": "/api/platform/branding/domains/{id}",
      "a": "RemoveDomain",
      "k": "none",
      "perm": "Branding"
     }
    ]
   },
   {
    "key": "Usage",
    "label": "Usage",
    "eps": [
     {
      "m": "GET",
      "p": "/api/platform/usage/summary",
      "a": "Summary",
      "k": "obj",
      "h": "groupBy: metric (default), day, tenant, campaign or department. from/to are UTC dates (to is inclusive); default is the current month.",
      "q": [
       {
        "n": "tenantId",
        "t": "g"
       },
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       },
       {
        "n": "includeChildren",
        "t": "b",
        "d": false
       },
       {
        "n": "groupBy",
        "t": "s"
       }
      ]
     },
     {
      "m": "GET",
      "p": "/api/platform/usage/limits",
      "a": "Limits",
      "k": "list"
     },
     {
      "m": "POST",
      "p": "/api/platform/usage/limits",
      "a": "CreateLimit",
      "k": "obj",
      "b": [
       {
        "n": "metric",
        "t": "s",
        "r": 1
       },
       {
        "n": "limitQuantity",
        "t": "n"
       },
       {
        "n": "warnPercent",
        "t": "n",
        "d": 80
       },
       {
        "n": "isEnabled",
        "t": "b",
        "d": true
       },
       {
        "n": "alertEmails",
        "t": "s"
       }
      ]
     },
     {
      "m": "PUT",
      "p": "/api/platform/usage/limits/{id}",
      "a": "UpdateLimit",
      "k": "obj",
      "b": [
       {
        "n": "metric",
        "t": "s",
        "r": 1
       },
       {
        "n": "limitQuantity",
        "t": "n"
       },
       {
        "n": "warnPercent",
        "t": "n",
        "d": 80
       },
       {
        "n": "isEnabled",
        "t": "b",
        "d": true
       },
       {
        "n": "alertEmails",
        "t": "s"
       }
      ]
     },
     {
      "m": "DELETE",
      "p": "/api/platform/usage/limits/{id}",
      "a": "DeleteLimit",
      "k": "none"
     },
     {
      "m": "GET",
      "p": "/api/platform/usage/allocation/rules",
      "a": "Rules",
      "k": "list"
     },
     {
      "m": "POST",
      "p": "/api/platform/usage/allocation/rules",
      "a": "CreateRule",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "matchMetric",
        "t": "s"
       },
       {
        "n": "matchCampaignId",
        "t": "g"
       },
       {
        "n": "splits",
        "t": "j",
        "r": 1
       },
       {
        "n": "isEnabled",
        "t": "b",
        "d": true
       }
      ]
     },
     {
      "m": "PUT",
      "p": "/api/platform/usage/allocation/rules/{id}",
      "a": "UpdateRule",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "priority",
        "t": "n",
        "d": 100
       },
       {
        "n": "matchMetric",
        "t": "s"
       },
       {
        "n": "matchCampaignId",
        "t": "g"
       },
       {
        "n": "splits",
        "t": "j",
        "r": 1
       },
       {
        "n": "isEnabled",
        "t": "b",
        "d": true
       }
      ]
     },
     {
      "m": "DELETE",
      "p": "/api/platform/usage/allocation/rules/{id}",
      "a": "DeleteRule",
      "k": "none"
     },
     {
      "m": "GET",
      "p": "/api/platform/usage/allocation/report",
      "a": "AllocationReport",
      "k": "obj",
      "h": "Usage with the allocation rules applied: how much each department used and cost.",
      "q": [
       {
        "n": "from",
        "t": "dt"
       },
       {
        "n": "to",
        "t": "dt"
       }
      ]
     }
    ]
   },
   {
    "key": "Billing",
    "label": "Billing",
    "eps": [
     {
      "m": "GET",
      "p": "/api/platform/billing/invoice-preview",
      "a": "InvoicePreview",
      "k": "obj",
      "h": "month is yyyy-MM (default: the current month). includeChildren prices the pooled usage of the sub-organisations too.",
      "q": [
       {
        "n": "tenantId",
        "t": "g"
       },
       {
        "n": "month",
        "t": "s"
       },
       {
        "n": "includeChildren",
        "t": "b",
        "d": false
       }
      ]
     },
     {
      "m": "GET",
      "p": "/api/platform/billing/closes",
      "a": "Closes",
      "k": "paged",
      "q": [
       {
        "n": "tenantId",
        "t": "g"
       }
      ],
      "qp": [
       "search",
       "sort",
       "desc"
      ]
     },
     {
      "m": "GET",
      "p": "/api/platform/billing/export",
      "a": "Export",
      "k": "file",
      "h": "format: csv (default) or json. view: usage (daily rows, default) or invoice (priced lines per organisation).",
      "q": [
       {
        "n": "tenantId",
        "t": "g"
       },
       {
        "n": "month",
        "t": "s"
       },
       {
        "n": "includeChildren",
        "t": "b",
        "d": false
       },
       {
        "n": "format",
        "t": "s"
       },
       {
        "n": "view",
        "t": "s"
       }
      ]
     }
    ]
   },
   {
    "key": "RatePlans",
    "label": "Rate plans",
    "eps": [
     {
      "m": "GET",
      "p": "/api/platform/admin/rate-plans",
      "a": "List",
      "k": "list"
     },
     {
      "m": "GET",
      "p": "/api/platform/admin/rate-plans/{id}",
      "a": "Get",
      "k": "obj"
     },
     {
      "m": "POST",
      "p": "/api/platform/admin/rate-plans",
      "a": "Create",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "currency",
        "t": "s",
        "r": 1,
        "d": "USD"
       },
       {
        "n": "monthlyFee",
        "t": "n"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "tiers",
        "t": "j"
       }
      ]
     },
     {
      "m": "PUT",
      "p": "/api/platform/admin/rate-plans/{id}",
      "a": "Update",
      "k": "obj",
      "b": [
       {
        "n": "name",
        "t": "s",
        "r": 1
       },
       {
        "n": "description",
        "t": "s"
       },
       {
        "n": "currency",
        "t": "s",
        "r": 1,
        "d": "USD"
       },
       {
        "n": "monthlyFee",
        "t": "n"
       },
       {
        "n": "isActive",
        "t": "b",
        "d": true
       },
       {
        "n": "tiers",
        "t": "j"
       }
      ]
     },
     {
      "m": "DELETE",
      "p": "/api/platform/admin/rate-plans/{id}",
      "a": "Delete",
      "k": "none"
     }
    ]
   },
   {
    "key": "Health",
    "label": "Health",
    "eps": [
     {
      "m": "GET",
      "p": "/api/platform/health",
      "a": "Get",
      "k": "obj"
     },
     {
      "m": "GET",
      "p": "/api/platform/health/runbook",
      "a": "Runbook",
      "k": "list"
     },
     {
      "m": "GET",
      "p": "/api/platform/health/history",
      "a": "History",
      "k": "obj",
      "h": "Sampled history of one component (a service name, \"sql\", \"redis\", \"events:dead-letter\", \"events:{consumer group}\").",
      "q": [
       {
        "n": "component",
        "t": "s"
       },
       {
        "n": "hours",
        "t": "n",
        "d": 24
       }
      ]
     }
    ]
   }
  ]
 }
];